// 1. Imports
import React, {
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
  useCallback
} from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useSelector, connect } from 'react-redux'
import axios from 'axios'
import moment from 'moment'

// 2. Third-party components
import ReactJson from 'react-json-view'
import ReactMarkdown from 'react-markdown'
import Lottie from 'react-lottie'
import EmojiPicker from 'emoji-picker-react'

// 3. UI Elements
import {
  Form,
  InputGroup,
  Button,
  Badge,
  Overlay,
  Tooltip,
  Offcanvas,
  Modal
} from 'react-bootstrap'

import {
  EmojiSmileFill,
  ChevronDown,
  PlusCircle,
  Image,
  Mic,
  Send,
  FilePdf,
  FiletypeDoc,
  FileText,
  File,
  FileEarmark,
  FiletypeXlsx,
  TypeBold,
  TypeItalic,
  Code,
  ListUl,
  ListOl,
  Quote
} from 'react-bootstrap-icons'

import {
  Check,
  Clock3,
  PhoneOff,
  Sticker,
  Speaker,
  SquareTerminal,
  Reply,
  SendHorizontal,
  CircleAlert,
  CircleX,
  Computer,
  CheckCheck
} from 'lucide-react'

// 4. Redux actions
import {
  setNotification,
  setSelectedChat,
  setSocketConnected,
  setShowCallModal,
  setCallDetails,
  setCallData,
  setChatList
} from '../../../features/data/dataSlice'

// 5. Custom components and config
import config from '../../../config'
import animationData from '../../../animations/typing.json'
import ReactionBar from './ReactionBar '
import CallingBubble from './callingBubble'
import LinkPreviewWithText from './LinkPreviewWithText'
import './UserChatView.css'

function UserChatView({
  setAction,
  selectedChat,
  setSelectedChat,
  userInfo,
  fetchAgain,
  setFetchAgain,
  setNotification,
  notification,
  authToken,
  socketConnected,
  setSocketConnected,
  setShowCallModal,
  setCallDetails,
  setChatList,
  setSocket,
  socket,
  setCallData
}) {
  var selectedChatCompare

  // UI state
  const [show, setShow] = useState(false)
  const [target, setTarget] = useState(null)
  const [isDark, setIsDark] = useState(
    document.body.classList.contains('dark-mode-active')
  )
  const [showSuggestions, setShowSuggestions] = useState(false)
  const [showsuggestion, setShowsuggestion] = useState(false)
  const [showStickerPicker, setShowStickerPicker] = useState(false)
  const [modalStickers, setModalStickers] = useState(false)
  const [showDropzone, setShowDropzone] = useState(false)
  const [showScrollToBottom, setShowScrollToBottom] = useState(false)
  const [showToolbar, setShowToolbar] = useState(false)
  const [showIframe, setShowIframe] = useState(false)
  const [poll, setPoll] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()

  // Chat & message state
  const [chatThreads, setchatThreads] = useState()
  const [messages, setMessages] = useState([])
  const [newMessage, setNewMessage] = useState('')
  const [typing, setTyping] = useState(false)
  const [istyping, setIsTyping] = useState(false)
  const [isUserTyping, setIsUserTyping] = useState(false)
  const [replyingTo, setReplyingTo] = useState(null)
  const [mentionList, setMentionList] = useState([])
  const [mentionIndex, setMentionIndex] = useState(-1)
  const [activesugget, setactivesugget] = useState([])
  const [linkToPreview, setLinkToPreview] = useState(null)
  const [receivedMessage, setReceivedMessage] = useState('Waiting...')
  const [messageBuffer, setMessageBuffer] = useState([])
  const [previewFile, setPreviewFile] = useState(null)
  const [offlineMessages, setOfflineMessages] = useState(
    JSON.parse(localStorage.getItem('offlineMessages')) || []
  )
  const [newMessageCount, setNewMessageCount] = useState(0)
  const [firstNewMessageRef, setFirstNewMessageRef] = useState(null)
  const [stickers, setStickers] = useState([])
  const [uploading, setUploading] = useState(false)

  // Poll state
  const [pollQuestion, setPollQuestion] = useState('')
  const [pollOptions, setPollOptions] = useState(['', ''])

  // Pagination & loading state
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const [isLoadingOlderMessages, setIsLoadingOlderMessages] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isInitialLoad, setIsInitialLoad] = useState(true)

  // Audio state
  const [isRecording, setIsRecording] = useState(false)
  const [mediaRecorder, setMediaRecorder] = useState(null)
  const [recordingTime, setRecordingTime] = useState(0)
  const [audioPlaying, setAudioPlaying] = useState({})
  const [audioProgress, setAudioProgress] = useState({})
  const [audioDuration, setAudioDuration] = useState({})

  // Notification & unread state
  const [unreadCount, setUnreadCount] = useState(0)
  const [firstUnreadMessage, setFirstUnreadMessage] = useState(null)
  const [showUnreadBadge, setShowUnreadBadge] = useState(false)

  // Toolbar selection
  const [selection, setSelection] = useState({ start: 0, end: 0 })
  const [toolbarPosition, setToolbarPosition] = useState({ top: 0, left: 0 })
  const [showEmojiPicker, setShowEmojiPicker] = useState(false)

  // Swipe & touch gesture state
  const [touchStartX, setTouchStartX] = useState(null)
  const [touchMoveX, setTouchMoveX] = useState(null)
  const [touchStartY, setTouchStartY] = useState(null)
  const [touchMoveY, setTouchMoveY] = useState(null)
  const [swipedMessage, setSwipedMessage] = useState(null)
  const [lockedAxis, setLockedAxis] = useState(null)

  // Call state
  const [callfullscreen, setCallFullscreen] = useState(true)
  const [call, setCall] = useState(false)
  const [previousCallUuid, setPreviousCallUuid] = useState(null)

  // Scroll position
  const [isAtBottom, setIsAtBottom] = useState(true)

  // useRef declaration
  const ref = useRef(null)
  const audioRefs = useRef({})
  const fileInputRef = useRef(null)
  const suggestionRef = useRef(null)
  const firstUnreadRef = useRef(null)
  const messageViewRef = useRef(null)
  const iframeRef = useRef(null)
  const mentionListRef = useRef(null)
  const mentionItemRefs = useRef([])
  const reconnectInterval = useRef(null)
  const previousScrollRef = useRef({ scrollTop: 0, scrollHeight: 0 })
  const chunkIntervalRef = useRef(null)
  const isPrependingRef = useRef(false)
  const textareaRef = useRef(null)
  const recordingTimerRef = useRef(null)
  const messagesEndRef = useRef(null)

  // Main Chat Suggestion Modal
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  // Iframe Modal
  const handleCloseFrame = () => setShowIframe(false)
  const handleShowFrame = () => setShowIframe(true)

  // Poll Modal
  const handleClosePoll = () => setPoll(false)
  const handleShowPoll = () => setPoll(true)

  // Sticker Modal
  const handleCloseStickers = () => setModalStickers(false)
  const handleShowStickers = () => {
    setModalStickers(true)
    setShowStickerPicker(!showStickerPicker)
    if (!showStickerPicker) fetchTenorStickers()
  }

  // Lottie animation for typing
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  }

  const navigate = useNavigate()
  const chatId = searchParams.get('chatId')

  const chatList = useSelector(state => state.data.chatList)
  const user = JSON.parse(localStorage.getItem('userInfo')) || {}

  //sending emoji
  const handleEmojiClick = emojiData => {
    setNewMessage(prevMessage => prevMessage + emojiData.emoji)
    setIsUserTyping(true)
  }

  // Close emoji picker when clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (
        showEmojiPicker &&
        !event.target.closest('.emoji-picker-container') &&
        !event.target.closest('.emoji-btn')
      ) {
        setShowEmojiPicker(false)
      }
    }

    document.addEventListener('click', handleClickOutside)
    return () => document.removeEventListener('click', handleClickOutside)
  }, [showEmojiPicker])
  // sending emoji finish

  const handlePollQuestionChange = e => {
    setPollQuestion(e.target.value)
  }

  const handlePollOptionChange = (index, value) => {
    const updatedOptions = [...pollOptions]
    updatedOptions[index] = value
    setPollOptions(updatedOptions)

    // Add a new empty option when both initial options are filled (max 5 options)
    if (
      index >= pollOptions.length - 1 &&
      value.trim() !== '' &&
      pollOptions.length < 5
    ) {
      setPollOptions([...updatedOptions, ''])
    }
  }

  // Function to manually add an option
  const addPollOption = () => {
    if (pollOptions.length < 5) {
      setPollOptions([...pollOptions, ''])
    }
  }

  // Function to check if the button should be enabled
  const isPollValid = () => {
    return (
      pollQuestion.trim() !== '' && pollOptions.every(opt => opt.trim() !== '')
    )
  }
  //poll finish

  useEffect(() => {
    if (mentionIndex >= 0 && mentionItemRefs.current[mentionIndex]) {
      mentionItemRefs.current[mentionIndex].scrollIntoView({
        block: 'nearest',
        behavior: 'smooth'
      })
    }
  }, [mentionIndex])

  useEffect(() => {
    // Handle offline mode
    const handleOfflineMode = () => {
      setSocketConnected(false)
      // console.log('Device is offline')
    }

    // Handle online mode
    const handleOnlineMode = () => {
      setSocketConnected(true)
      connectWebSocket()
      if (selectedChat && selectedChat._id === chatId) {
        fetchMessages()
      }
      // console.log('Device is online')
    }

    // Add event listeners
    window.addEventListener('offline', handleOfflineMode)
    window.addEventListener('online', handleOnlineMode)

    // Set initial state based on navigator.onLine
    setSocketConnected(navigator.onLine)

    // Cleanup function to remove event listeners
    return () => {
      window.removeEventListener('offline', handleOfflineMode)
      window.removeEventListener('online', handleOnlineMode)
    }
  }, [])

  //fetchChatDetails
  useEffect(() => {
    const fetchChatDetails = async () => {
      try {
        const head = {
          headers: {
            Authorization: `Bearer ${authToken}`
          }
        }
        const response = await axios.get(`${config.devapi}chat`, head)

        if (response?.data?.length > 0) {
          const currentChat = response.data.find(chat => chat._id === chatId)
          if (currentChat) {
            setchatThreads(currentChat)
            setSelectedChat(currentChat)
          }
        }
      } catch (error) {
        console.error('Error fetching chat details:', error)
      }
    }

    if (chatId) {
      const cachedChat = localStorage.getItem(`chat_${chatId}`)
      if (cachedChat) {
        const parsedChat = JSON.parse(cachedChat)
        setchatThreads(parsedChat)
        setSelectedChat(parsedChat)
      }
      fetchChatDetails()
    }

    // Reset badge state when navigating away
    return () => {
      setShowUnreadBadge(false)
      setUnreadCount(0)
      setFirstUnreadMessage(null)
    }
  }, [chatId, authToken])

  // Reset replyingTo when chatId changes
  useEffect(() => {
    setReplyingTo(null)
  }, [chatId])

  // Helper function to compare timestamps within a 1-second window
  const isSameTime = (clientTime, serverTime) => {
    const clientDate = new Date(clientTime)
    const serverDate = new Date(serverTime)
    return Math.abs(clientDate - serverDate) < 1000 // Within 1 second
  }

  // Utility to chunk messages
  const chunkArrayFromEnd = (array, size) => {
    const result = []
    for (let i = array.length; i > 0; i -= size) {
      result.push(array.slice(Math.max(0, i - size), i))
    }
    return result
  }

  useLayoutEffect(() => {
    if (!isPrependingRef.current || !messageViewRef.current) return
    const messageView = messageViewRef.current
    const delta =
      messageView.scrollHeight - previousScrollRef.current.scrollHeight
    messageView.scrollTop = previousScrollRef.current.scrollTop + delta
    isPrependingRef.current = false
  }, [messages])

  // Modified fetchMessages for chunked loading
  const fetchMessages = async (pageNum = 1, isInitialLoad = false) => {
    if (!selectedChat || !socket) return

    const messageView = messageViewRef.current
    if (!messageView) return

    if (pageNum > 1 && !isInitialLoad) {
      previousScrollRef.current = {
        scrollTop: messageView.scrollTop,
        scrollHeight: messageView.scrollHeight
      }
      isPrependingRef.current = true
    }

    try {
      const head = {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      }

      if (pageNum > 1 && !isInitialLoad) {
        setIsLoadingOlderMessages(true)
      }
      setLoading(true)

      const { data } = await axios.get(
        `${config.devapi}message/${selectedChat._id}?page=${pageNum}&limit=50`,
        head
      )

      let serverMessages = data.map(msg => ({
        ...msg,
        status: msg.status || 'sent',
        chat: msg.chat || { _id: selectedChat._id }
      }))

      if (serverMessages.length < 50) {
        setHasMore(false)
      }

      if (!isInitialLoad && pageNum > 1) {
        const chunks = chunkArrayFromEnd(serverMessages, 2)
        let chunkIndex = 0

        chunkIntervalRef.current = setInterval(() => {
          if (chunkIndex >= chunks.length) {
            clearInterval(chunkIntervalRef.current)
            setIsLoadingOlderMessages(false)
            setLoading(false)
            return
          }

          setMessages(prev => [...chunks[chunkIndex], ...prev])
          chunkIndex++
        }, 1200)

        setPage(pageNum)
        return
      }

      setMessages(serverMessages)

      if (isInitialLoad) {
        const currentUserInChat = chatThreads?.users.find(
          u => u._id === user._id
        )
        const lastSeen = currentUserInChat?.lastSeen
          ? new Date(currentUserInChat.lastSeen)
          : new Date(0)

        const unreadMessages = serverMessages.filter(
          msg =>
            new Date(msg.createdAt) > lastSeen && msg.sender._id !== user._id
        )

        setUnreadCount(unreadMessages.length)
        setFirstUnreadMessage(unreadMessages[0] || null)
        setShowUnreadBadge(unreadMessages.length > 0)
      }

      setLoading(false)
      setIsLoadingOlderMessages(false)
      setPage(pageNum)

      socket.send(
        JSON.stringify({ type: 'join chat', chatId: selectedChat._id })
      )
    } catch (error) {
      console.error('Error fetching messages:', error)
      setLoading(false)
      setIsLoadingOlderMessages(false)
    }
  }

  // useEffect for loading chat again when navigating back to the chat
  useEffect(() => {
    setPage(1) // Reset page number
    setHasMore(true) // Allow fetching again
    setMessages([]) // Optional: clear previous messages
    setIsInitialLoad(true) // So scroll-to-bottom logic works

    if (selectedChat && selectedChat._id === chatId) {
      fetchMessages(1, true) // Trigger new fetch
    }
  }, [selectedChat, chatId])

  useEffect(() => {
    const messageView = messageViewRef.current
    if (!messageView) {
      console.log('messageViewRef is null')
      return
    }

    let scrollTimeout
    const handleScroll = () => {
      clearTimeout(scrollTimeout)
      scrollTimeout = setTimeout(() => {
        const scrollTop = messageView.scrollTop
        const scrollHeight = messageView.scrollHeight
        const clientHeight = messageView.clientHeight
        const scrollThreshold = 105 // Trigger fetch when 105px from top
        const bottomThreshold = 50 // Consider "at bottom" within 50px

        // Adjust for 52px header height
        const adjustedScrollTop = scrollTop + 52

        // Check if user is near the bottom
        const isAtBottom =
          scrollHeight - scrollTop - clientHeight < bottomThreshold
        setShowScrollToBottom(!isAtBottom && messages.length > 4)

        // Fetch older messages when near the top
        if (
          adjustedScrollTop < scrollThreshold &&
          hasMore &&
          !loading &&
          !isLoadingOlderMessages
        ) {
          // console.log('Near top, triggering fetch for page', page + 1)
          fetchMessages(page + 1, false) // Fetch next page with chunked loading
        }
      }, 200) // Debounce for 200ms
    }

    messageView.addEventListener('scroll', handleScroll)
    return () => {
      messageView.removeEventListener('scroll', handleScroll)
      clearTimeout(scrollTimeout)
    }
  }, [
    page,
    hasMore,
    loading,
    isLoadingOlderMessages,
    selectedChat,
    socket,
    authToken,
    offlineMessages,
    messages.length
  ])

  useEffect(() => {
    if (selectedChat && selectedChat._id === chatId) {
      fetchMessages(1, true) // Initial load with page 1
      selectedChatCompare = selectedChat

      if (selectedChat) {
        setNewMessage('')
        setIsUserTyping(false)
        setShowSuggestions(false)
      }
    }
  }, [selectedChat, chatId, offlineMessages, socket, authToken])

  //connectWebSocket
  const connectWebSocket = () => {
    // console.log('connectWebSocket function triggered!')
    const ws = new WebSocket('wss://api.airmsg.me')

    ws.onopen = () => {
      setSocketConnected(true)
      ws.send(JSON.stringify({ type: 'setup', user }))

      // Only fetch messages if a chat is selected and matches chatId
      if (selectedChat && selectedChat._id === chatId) {
        fetchMessages()
      }

      // Clear any existing reconnect attempts
      if (reconnectInterval.current) {
        clearTimeout(reconnectInterval.current)
        reconnectInterval.current = null
      }

      // Send ping every 20 seconds
      const pingInterval = setInterval(() => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify({ type: 'ping', userid: user._id }))
        }
      }, 20000)
      ws.pingInterval = pingInterval
    }

    ws.onmessage = event => {
      const data = JSON.parse(event.data)
      if (data.type === 'typing') {
        setIsTyping(true)
      } else if (data.type === 'stop typing') {
        setIsTyping(false)
      } else if (data.type === 'pong') {
        // console.log('Pong received')
      } else if (data.type === 'user disconnected') {
        if (selectedChat) {
          let disconnectedUser
          if (!selectedChat.isGroupChat) {
            disconnectedUser = selectedChat.users.find(
              user => user._id !== userInfo._id
            )
          } else {
            disconnectedUser = selectedChat.users.find(
              user => user._id === data.userId
            )
          }
          // if (disconnectedUser) {
          //   console.log(
          //     `Disconnected User: ID=${disconnectedUser._id}, Name=${disconnectedUser.name}`
          //   )
          // } else {
          //   console.log(`User ID ${data.userId} not found in this chat.`)
          // }
        }
      }
    }

    ws.onclose = () => {
      setSocketConnected(false)
      // console.log('Disconnected from WebSocket')

      // Clear ping interval
      if (ws.pingInterval) {
        clearInterval(ws.pingInterval)
      }

      // Attempt to reconnect after 5 seconds
      if (!reconnectInterval.current) {
        reconnectInterval.current = setTimeout(() => {
          // console.log('Reconnecting to WebSocket...')
          connectWebSocket()
          // fetchMessages()
          setFetchAgain(!fetchAgain)
        }, 5000)
      }
    }

    setSocket(ws)
  }

  useEffect(() => {
    connectWebSocket() // Initial connection
    // console.log('connected')

    return () => {
      if (reconnectInterval.current) {
        clearTimeout(reconnectInterval.current)
      }
      if (socket) {
        if (socket.pingInterval) {
          clearInterval(socket.pingInterval)
        }
        socket.close()
      }
    }
  }, [])

  useEffect(async () => {
    const head = {
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    }
    const response = await axios.get(`${config.devapi}chat`, head)
    if (response?.data?.length > 0) {
      response?.data?.map((v, k) => {
        if (chatId == v._id) {
          setchatThreads(v)
        }
      })
    }
  }, [chatId])

  const filteredMessages = messages.filter(msg => msg?.chat?._id === chatId)

  const groupedMessages = filteredMessages.reduce((acc, message) => {
    const messageDate = moment(message.createdAt)
    let displayDate

    if (messageDate.isSame(moment(), 'day')) {
      displayDate = 'Today'
    } else if (messageDate.isSame(moment().subtract(1, 'day'), 'day')) {
      displayDate = 'Yesterday'
    } else if (messageDate.isAfter(moment().subtract(5, 'days'))) {
      displayDate = messageDate.format('dddd') // Show day name (Monday, Tuesday, etc.)
    } else {
      displayDate = messageDate.format('MMM D, YYYY') // Show full date
    }

    if (!acc[displayDate]) acc[displayDate] = []
    acc[displayDate].push(message)
    return acc
  }, {})

  // Handle Enter & arrow key press
  const handleKeyPress = e => {
    if (showSuggestions && mentionList.length > 0) {
      if (e.key === 'ArrowDown') {
        e.preventDefault()
        setMentionIndex(prevIndex =>
          prevIndex < mentionList.length - 1 ? prevIndex + 1 : 0
        )
      } else if (e.key === 'ArrowUp') {
        e.preventDefault()
        setMentionIndex(prevIndex =>
          prevIndex > 0 ? prevIndex - 1 : mentionList.length - 1
        )
      } else if (e.key === 'Enter') {
        e.preventDefault()
        if (mentionIndex >= 0 && mentionIndex < mentionList.length) {
          insertMention(mentionList[mentionIndex], textareaRef.current)
        }
      }
      return
    }

    if (e.key === 'Enter') {
      e.preventDefault()
      sendMessage(e)
    }
  }

  //checking the cursor position when backtracking in @ trigger
  const checkCursorPosition = e => {
    const textarea = e.target
    const cursorPos = textarea.selectionStart
    const textBeforeCursor = textarea.value.substring(0, cursorPos)
    const textAfterCursor = textarea.value.substring(cursorPos)

    // Find the last '@' before the cursor
    const lastAtIndex = textBeforeCursor.lastIndexOf('@')

    // Check if cursor is within or immediately after a mentionable context
    if (lastAtIndex !== -1 && cursorPos > lastAtIndex) {
      const textAfterAt = textBeforeCursor.substring(lastAtIndex + 1)
      const nextSpaceIndex = textAfterAt.indexOf(' ')
      const isCursorInWord =
        nextSpaceIndex === -1 || cursorPos <= lastAtIndex + 1 + nextSpaceIndex

      if (isCursorInWord && !textAfterCursor.startsWith(' ')) {
        const searchTerm =
          nextSpaceIndex === -1
            ? textAfterAt
            : textAfterAt.substring(0, nextSpaceIndex)

        if (selectedChat?.isGroupChat) {
          const filteredUsers = selectedChat.users
            .filter(users => users._id !== user._id)
            .filter(user =>
              user.name.toLowerCase().includes(searchTerm.toLowerCase())
            )

          setMentionList(filteredUsers)
          setShowSuggestions(filteredUsers.length > 0)

          // Only set mentionIndex if suggestions are just appearing
          if (!showSuggestions && filteredUsers.length > 0) {
            setMentionIndex(0) // Initialize to 0 only when list first shows
          } else if (filteredUsers.length === 0) {
            setMentionIndex(-1) // Reset to -1 if no matches
          }
        } else {
          setShowSuggestions(false)
          setMentionIndex(-1)
        }
      } else {
        // Cursor is after a completed mention (followed by space), so hide suggestions
        setShowSuggestions(false)
        setMentionIndex(-1)
      }
    } else {
      // No '@' before cursor or cursor is before '@', so hide suggestions
      setShowSuggestions(false)
      setMentionIndex(-1)
    }
  }

  //autocomplete name in text area when @ is triggered
  const insertMention = (selectedUser, textarea) => {
    const cursorPos = textarea ? textarea.selectionStart : newMessage.length
    const textBeforeCursor = newMessage.substring(0, cursorPos)
    const textAfterCursor = newMessage.substring(cursorPos)

    const lastAtIndex = textBeforeCursor.lastIndexOf('@')
    if (lastAtIndex !== -1) {
      // Find the end of the current word (space or end of string)
      const textAfterAt = newMessage.substring(lastAtIndex + 1)
      const endOfWordIndex = textAfterAt.indexOf(' ')
      const endOfMention =
        endOfWordIndex === -1
          ? newMessage.length
          : lastAtIndex + 1 + endOfWordIndex

      // Replace the partial mention with the selected user's name followed by a space
      const newTextBefore = newMessage.substring(0, lastAtIndex)
      const newTextAfter = newMessage.substring(endOfMention)
      const newMessageText = `${newTextBefore}@${selectedUser.name} ${newTextAfter}` // Always add a space after the name
      setNewMessage(newMessageText)

      setShowSuggestions(false)
      setMentionIndex(-1)

      // Move cursor to after the space following the inserted name
      if (textarea) {
        setTimeout(() => {
          const newCursorPos = lastAtIndex + selectedUser.name.length + 2 // +2 for '@' and space
          textarea.setSelectionRange(newCursorPos, newCursorPos)
          textarea.focus()
        }, 0)
      }
    } else {
      // Fallback: append with a space if no '@' found
      const newMessageText = `${newMessage}@${selectedUser.name} `
      setNewMessage(newMessageText)

      setShowSuggestions(false)
      setMentionIndex(-1)

      if (textarea) {
        setTimeout(() => {
          const newCursorPos = newMessageText.length
          textarea.setSelectionRange(newCursorPos, newCursorPos)
          textarea.focus()
        }, 0)
      }
    }
  }
  // console.log(replyingTo)
  // console.log(groupedMessages)

  function handleSentMssage(fromFunction, fromData = {}) {
    if (fromFunction === '') return

    const DocumentMessage = {
      type: 'new message2',
      message: {
        // Assume uuid is already present in the message object
        createdAt: new Date().toISOString(),
        chatId: {
          isGroupChat: selectedChat.isGroupChat,
          users: selectedChat.users,
          _id: selectedChat._id,
          chatName: selectedChat.isGroupChat ? selectedChat.chatName : null,
          createdAt: selectedChat.createdAt || new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          __v: 0,
          sender: {
            _id: user._id,
            name: user.name
          }
        },
        chat: { _id: selectedChat._id }, // Add for filtering
        sender: {
          _id: user._id,
          name: user.name
        },
        status: socketConnected ? 'sending' : 'pending',
        replyTo: replyingTo
          ? {
              uuid: replyingTo.uuid,
              type: replyingTo.type,
              sender: replyingTo.sender.name,
              mapPreview: replyingTo.mapPreview,
              content: replyingTo.content
            }
          : null
      }
    }

    // Log if uuid is missing
    if (!DocumentMessage.message.uuid) {
      console.warn('Message missing uuid:', DocumentMessage.message)
    }

    if (fromFunction === 'text') {
      DocumentMessage.message.content = fromData.content
      DocumentMessage.message.type = fromData.type
    } else if (fromFunction === 'file') {
      DocumentMessage.message.content = fromData.content
      DocumentMessage.message.type = fromData.type
    } else if (fromFunction === 'location') {
      DocumentMessage.message.content = fromData.content
      DocumentMessage.message.type = fromData.type
      DocumentMessage.message.mapPreview = fromData.mapPreview
      DocumentMessage.message.coordinates = fromData.coordinates
    } else if (fromFunction === 'poll') {
      DocumentMessage.message.content = fromData.content
      DocumentMessage.message.type = fromData.type
    } else if (fromFunction === 'sticker') {
      DocumentMessage.message.content = fromData.content
      DocumentMessage.message.type = fromData.type
    } else if (fromFunction === 'emoji') {
      DocumentMessage.message.content = fromData.content
      DocumentMessage.message.type = 'emoji'
    } else if (fromFunction === 'link') {
      DocumentMessage.message.content = fromData.content
      DocumentMessage.message.type = fromData.type
      DocumentMessage.message.linkPreview = fromData.linkPreview
    } else if (fromFunction === 'audio') {
      DocumentMessage.message.content = fromData.content
      DocumentMessage.message.type = 'audio'
      DocumentMessage.message.fileName = fromData.fileName
    }

    // Immediately add to UI
    setMessages(prevMessages => {
      const messageExists = prevMessages.some(
        msg => msg.uuid && msg.uuid === DocumentMessage.message.uuid
      )
      if (messageExists) {
        console.log(
          'Message already exists in UI:',
          DocumentMessage.message.uuid
        )
        return prevMessages
      }
      // console.log('Adding message to UI:', DocumentMessage.message)
      return [...prevMessages, DocumentMessage.message]
    })

    if (socketConnected && socket) {
      try {
        // console.log('Sending message with uuid:', DocumentMessage.message.uuid)
        socket.send(JSON.stringify(DocumentMessage))
        setMessages(prevMessages =>
          prevMessages.map(msg =>
            msg.uuid === DocumentMessage.message.uuid
              ? { ...msg, status: 'sending' }
              : msg
          )
        )

        // Use serializable value only
        if (chatList && setChatList) {
          const updatedChatList = chatList.map(chat =>
            chat._id === selectedChat._id
              ? { ...chat, latestMessage: { ...DocumentMessage.message } }
              : chat
          )
          setChatList(updatedChatList)
        }
      } catch (error) {
        console.error('Error sending message:', error)
        setMessages(prevMessages =>
          prevMessages.map(msg =>
            msg.uuid === DocumentMessage.message.uuid
              ? { ...msg, status: 'pending' }
              : msg
          )
        )
        // Store in offline messages
        setOfflineMessages(prev => {
          const updatedOfflineMessages = [
            ...prev,
            { ...DocumentMessage, message: { ...DocumentMessage.message } }
          ]
          localStorage.setItem(
            'offlineMessages',
            JSON.stringify(updatedOfflineMessages)
          )
          return updatedOfflineMessages
        })
      }
    } else {
      // Store in offline messages
      setMessages(prevMessages =>
        prevMessages.map(msg =>
          msg.uuid === DocumentMessage.message.uuid
            ? { ...msg, status: 'pending' }
            : msg
        )
      )
      setOfflineMessages(prev => {
        const updatedOfflineMessages = [
          ...prev,
          {
            ...DocumentMessage,
            message: { ...DocumentMessage.message, status: 'pending' }
          }
        ]
        localStorage.setItem(
          'offlineMessages',
          JSON.stringify(updatedOfflineMessages)
        )
        return updatedOfflineMessages
      })
    }

    // Clear the reply box after sending the message
    setReplyingTo(null)
  }

  const isOnlyEmojis = str => {
    // Remove whitespace and check if remaining characters are emojis
    const trimmedStr = str.replace(/\s/g, '')
    // Emoji regex (covers a wide range of Unicode emojis)
    const emojiRegex = /^[\p{Emoji_Presentation}|\p{Emoji}\u200D]+$/u
    return trimmedStr.length > 0 && emojiRegex.test(trimmedStr)
  }

  //text & link msg
  const sendMessage = async e => {
    e.preventDefault()
    if (!socket || !selectedChat) return

    // If there's a file to upload, handle the file upload
    if (previewFile) {
      await handleUpload()
      return
    }

    // Otherwise, send the text or link message
    if (!newMessage.trim()) return

    try {
      setNewMessage('')
      setIsUserTyping(false)
      setTyping(false)
      setLinkToPreview(null)

      // Detect URL in the message
      const urlRegex = /(https?:\/\/[^\s]+)/g
      const urls = newMessage.match(urlRegex)

      if (urls && urls.length > 0) {
        // If there's a URL, treat it as a "link" type but keep the full content
        const linkMessage = {
          content: newMessage, // Store the full message (text + URL)
          type: 'link' // Mark as link type
        }
        handleSentMssage('link', linkMessage)
      } else if (isOnlyEmojis(newMessage)) {
        // If the message contains only emojis, treat it as an "emoji" type
        const emojiMessage = {
          content: newMessage,
          type: 'emoji'
        }
        handleSentMssage('text', emojiMessage) // Using 'text' as per handleSentMssage structure
      } else {
        // Otherwise, treat as plain text (includes text with emojis)
        const textMessage = {
          content: newMessage,
          type: 'text'
        }
        handleSentMssage('text', textMessage)
      }
    } catch (error) {
      console.error(error)
    }
    // Reset textarea height to original 40px
    if (textareaRef.current) {
      textareaRef.current.style.height = '40px'
    }
  }

  //location
  const sendLocation = async () => {
    // console.log('sendLocation called')
    if (!navigator.geolocation) {
      alert('Geolocation is not supported by your browser')
      return
    }

    if (!socket || !selectedChat) {
      alert('Socket or chat not available')
      return
    }

    try {
      setNewMessage('') // Clear input field
      setIsUserTyping(false) // Reset isTyping state
      setTyping(false) // Reset typing state
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        })
      })

      const { latitude, longitude } = position.coords
      const zoomLevel = 18
      const tileX = Math.floor(((longitude + 180) / 360) * 2 ** zoomLevel)
      const tileY = Math.floor(
        ((1 -
          Math.log(
            Math.tan((latitude * Math.PI) / 180) +
              1 / Math.cos((latitude * Math.PI) / 180)
          ) /
            Math.PI) /
          2) *
          2 ** zoomLevel
      )
      const mapPreviewUrl = `https://tile.openstreetmap.org/${zoomLevel}/${tileX}/${tileY}.png`
      const locationMessage = {
        content: `https://maps.google.com/?q=${latitude},${longitude}`,
        coordinates: { latitude, longitude },
        mapPreview: mapPreviewUrl,
        type: 'location'
      }
      handleSentMssage('location', locationMessage)
    } catch (error) {
      console.error('Error getting location:', error)
      alert('Failed to get location. Please allow location access.')
    }
  }

  //file upload
  const handleFileChange = e => {
    const file = e.target.files[0]
    if (file) {
      const previewUrl = URL.createObjectURL(file)
      setPreviewFile({
        file: file,
        preview: previewUrl,
        type: file.type,
        name: file.name
      })
      setIsUserTyping(true) // Show the send button by setting isUserTyping to true
    }
  }

  const handleUpload = async () => {
    // console.log('sendLocation called')
    if (!previewFile) return

    try {
      // setNewMessage('') // Clear input field
      // setIsUserTyping(false) // Reset isTyping state
      // setTyping(false) // Reset typing state
      setUploading(true)
      const formData = new FormData()
      formData.append('upload', previewFile.file)
      // formData.append('chatId', selectedChat._id)

      const head = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${user.token}`
        }
      }

      const { data } = await axios.post(
        `${config.devapi}upload`,
        formData
        // head
      )
      const DocumentMessage = {
        content: data.fileUrl,
        type: 'file'
      }
      handleSentMssage('file', DocumentMessage)
      setPreviewFile(null) // Clear preview
      URL.revokeObjectURL(previewFile.preview) // Clean up preview URL
      setUploading(false)
      setIsUserTyping(false)
    } catch (error) {
      console.error('Error uploading file:', error)
      alert('Failed to upload file. Please try again.')
      setUploading(false)
    }
  }

  //poll
  const sendPoll = () => {
    if (!isPollValid()) return

    if (!socket || !selectedChat) {
      alert('Socket or chat not available')
      return
    }

    try {
      const pollData = {
        type: 'poll',
        question: pollQuestion,
        options: pollOptions
      }

      // Close modal & reset poll state
      setPollQuestion('')
      setPollOptions(['', ''])
      handleClosePoll()

      handleSentMssage('poll', pollData)
    } catch (error) {
      console.error('Failed to send poll', error)
      alert('Failed to send poll')
    }
  }

  useEffect(() => {
    if (socketConnected && socket && offlineMessages.length > 0) {
      const sendQueuedMessages = async () => {
        try {
          for (const message of offlineMessages) {
            if (message.message.status === 'sending') continue

            // Update status to 'sending'
            setOfflineMessages(prev =>
              prev.map(m =>
                m.message.uuid === message.message.uuid
                  ? { ...m, message: { ...m.message, status: 'sending' } }
                  : m
              )
            )
            setMessages(prevMessages =>
              prevMessages.map(msg =>
                msg.uuid === message.message.uuid
                  ? {
                      ...msg,
                      status: 'sending',
                      chat: { _id: selectedChat._id }
                    }
                  : msg
              )
            )

            // Send the message
            console.log('Sending offline message:', message.message.uuid)
            socket.send(JSON.stringify(message))

            // Remove from offlineMessages
            setOfflineMessages(prev => {
              const updatedOfflineMessages = prev.filter(
                m => m.message.uuid !== message.message.uuid
              )
              localStorage.setItem(
                'offlineMessages',
                JSON.stringify(updatedOfflineMessages)
              )
              return updatedOfflineMessages
            })
          }
        } catch (error) {
          console.error('Error sending queued messages:', error)
          setOfflineMessages(prev =>
            prev.map(m =>
              m.message.status === 'sending'
                ? { ...m, message: { ...m.message, status: 'pending' } }
                : m
            )
          )
          setMessages(prevMessages =>
            prevMessages.map(msg =>
              msg.status === 'sending'
                ? { ...msg, status: 'pending', chat: { _id: selectedChat._id } }
                : msg
            )
          )
        }
      }

      sendQueuedMessages()
    }
  }, [socketConnected, socket, offlineMessages, selectedChat])

  //typing handler
  const typingHandler = e => {
    const message = e.target.value
    setNewMessage(message)
    setIsUserTyping(message.trim().length > 0)

    if (!socketConnected || !socket) return

    // Check cursor position after typing
    checkCursorPosition(e)

    // Detect complete URL (ends with space or end of string)
    const urlRegex = /(https?:\/\/[^\s]+)/g
    const urls = message.match(urlRegex)
    if (urls && urls.length > 0) {
      const lastUrl = urls[urls.length - 1]
      const urlEndIndex = message.indexOf(lastUrl) + lastUrl.length
      const isUrlComplete =
        urlEndIndex === message.length || message[urlEndIndex] === ' '
      if (isUrlComplete) {
        setLinkToPreview(lastUrl)
      } else {
        setLinkToPreview(null) // Clear preview if URL is incomplete
      }
    } else {
      setLinkToPreview(null) // No URL detected
    }

    // Existing typing logic...
    if (!typing) {
      setTyping(true)
      socket.send(JSON.stringify({ type: 'typing', chatId: selectedChat._id }))
    }

    let lastTypingTime = new Date().getTime()
    const timerLength = 3000

    setTimeout(() => {
      const timeNow = new Date().getTime()
      const timeDiff = timeNow - lastTypingTime

      if (timeDiff >= timerLength && typing) {
        socket.send(
          JSON.stringify({ type: 'stop typing', chatId: selectedChat._id })
        )
        setTyping(false)
      }
    }, timerLength)
  }

  // Clear input text when clicking close-circle
  const clearInput = () => {
    setNewMessage('')
    setIsUserTyping(false)
    setShowSuggestions(false)
    setTyping(false)
    setLinkToPreview(null) // Clear link preview
    setactivesugget('')
    // Reset textarea height to original 40px
    if (textareaRef.current) {
      textareaRef.current.style.height = '40px'
    }

    if (socketConnected && socket) {
      socket.send(
        JSON.stringify({ type: 'stop typing', chatId: selectedChat._id })
      )
    }
  }

  // Tenor API Fetch Function for stickers
  const fetchTenorStickers = async () => {
    try {
      const response = await fetch(
        `https://tenor.googleapis.com/v2/search?q=funny&key=AIzaSyC90IIiIl33ZzM2GKlCHQTHahEeHFcFVVM&limit=24`
      )
      const data = await response.json()
      setStickers(data.results)
    } catch (error) {
      console.error('Error fetching stickers:', error)
    }
  }

  // Function to Send Stickers
  const sendSticker = stickerUrl => {
    if (!stickerUrl) return

    try {
      const stickerMessage = {
        content: stickerUrl,
        type: 'sticker'
      }

      handleSentMssage('sticker', stickerMessage)
    } catch (error) {
      console.error('Failed to send sticker', error)
      alert('Failed to send sticker')
    }
    setShowStickerPicker(false) // Close sticker picker after selection
  }

  // server sends msg as input msg received
  useEffect(() => {
    if (!socket) return

    const handleMessageReceived = event => {
      try {
        const newMessageReceived = JSON.parse(event.data)

        if (newMessageReceived.type === 'message received') {
          const updatedMessage = newMessageReceived.message

          // Use current chatList to update Redux with latest message
          if (chatList && setChatList) {
            const updatedChatList = chatList.map(chat =>
              chat._id === updatedMessage.chat._id
                ? { ...chat, latestMessage: { ...updatedMessage } }
                : chat
            )
            setChatList(updatedChatList)
          }

          if (
            updatedMessage.chat._id !== selectedChat?._id &&
            updatedMessage.sender._id !== user._id
          ) {
            setNotification([
              ...notification,
              { chat: updatedMessage.chat, message: updatedMessage }
            ])
          }

          // Send message to iframe if modal is open and message is from the same chat
          if (
            showIframe &&
            iframeRef.current &&
            updatedMessage.chat?._id === selectedChat._id
          ) {
            try {
              console.log('Sending message to iframe:', updatedMessage)
              iframeRef.current.contentWindow.postMessage(
                { message: updatedMessage },
                'https://skyq.tech'
              )
            } catch (error) {
              console.error('Error sending message to iframe:', error)
            }
          }

          setMessages(prevMessages => {
            const messageIndex = prevMessages.findIndex(
              msg =>
                (msg.uuid && msg.uuid === updatedMessage.uuid) ||
                (msg._id && msg._id === updatedMessage._id) ||
                (isSameTime(msg.createdAt, updatedMessage.createdAt) &&
                  msg.sender?._id === updatedMessage.sender?._id)
            )

            if (messageIndex !== -1) {
              return prevMessages.map((msg, index) =>
                index === messageIndex
                  ? {
                      ...msg,
                      ...updatedMessage,
                      status: 'sent',
                      chat: updatedMessage.chat || { _id: selectedChat._id }
                    }
                  : msg
              )
            } else {
              const newMessage = {
                ...updatedMessage,
                status: 'sent',
                chat: updatedMessage.chat || { _id: selectedChat._id }
              }
              return [...prevMessages, newMessage]
            }
          })

          if (isAtBottom && messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' })
          }
        }
      } catch (error) {
        console.error('Error processing WebSocket message:', error, event.data)
      }
    }

    socket.addEventListener('message', handleMessageReceived)

    return () => {
      socket.removeEventListener('message', handleMessageReceived)
    }
  }, [
    socket,
    selectedChat,
    previousCallUuid,
    showIframe,
    setMessages,
    setNewMessageCount,
    setFirstNewMessageRef,
    notification,
    setNotification,
    user._id,
    chatList,
    setChatList,
    setCallData,
    setShowCallModal
  ])

  // scroll to bottom after chat is open
  useEffect(() => {
    const messageView = messageViewRef.current
    if (!messageView) return

    const timeout = setTimeout(() => {
      if (messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({ behavior: 'auto' })
      }
    }, 100) // Allow some delay for rendering

    return () => clearTimeout(timeout)
  }, [chatId])

  useEffect(() => {
    setIsInitialLoad(true) // Reset on chat change

    const delayAndFetch = async () => {
      await new Promise(resolve => setTimeout(resolve, 1000)) // 1 second delay
      fetchMessages(1, true)
    }

    delayAndFetch()

    selectedChatCompare = selectedChat
    if (selectedChat) {
      setNewMessage('')
      setIsUserTyping(false)
      setShowSuggestions(false)
    }
  }, [selectedChat, offlineMessages, socket, authToken])

  // Helper function to format time (e.g., "0:05" or "1:23")
  const formatTime = seconds => {
    if (!isFinite(seconds) || isNaN(seconds)) return '0:00'
    const minutes = Math.floor(seconds / 60)
    const secs = Math.floor(seconds % 60)
    return `${minutes}:${secs < 10 ? '0' + secs : secs}`
  }

  useEffect(() => {
    return () => {
      Object.values(audioRefs.current).forEach(audio => {
        audio.pause()
        audio.src = ''
      })
    }
  }, [audioRefs])

  // Start recording audio
  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      const recorder = new MediaRecorder(stream)
      const audioChunks = []

      recorder.ondataavailable = event => audioChunks.push(event.data)

      recorder.onstop = () => {
        const audioBlob = new Blob(audioChunks, { type: 'audio/webm' })
        sendAudioMessage(audioBlob, recordingTime) // Pass recordingTime as duration
        stream.getTracks().forEach(track => track.stop())
        setIsRecording(false)
        clearInterval(recordingTimerRef.current)
        setRecordingTime(0)
      }

      setMediaRecorder(recorder)
      recorder.start()
      setIsRecording(true)

      // Start counting up from 0 to 60 seconds
      setRecordingTime(0)
      recordingTimerRef.current = setInterval(() => {
        setRecordingTime(prev => {
          if (prev >= 60) {
            clearInterval(recordingTimerRef.current)
            if (recorder.state !== 'inactive') {
              recorder.stop()
            }
            return 60
          }
          return prev + 1
        })
      }, 1000)
    } catch (error) {
      console.error('Error starting recording:', error)
      alert('Failed to start recording. Please allow microphone access.')
    }
  }

  // stop recording
  const stopRecording = () => {
    if (mediaRecorder && mediaRecorder.state !== 'inactive') {
      mediaRecorder.stop()
      setIsRecording(false)
      clearInterval(recordingTimerRef.current) // Clear the interval if stopped manually
      setRecordingTime(0) // Reset timer
    }
  }

  // Send audio message
  const sendAudioMessage = async (audioBlob, duration) => {
    if (!audioBlob || !socket || !selectedChat) return

    const reader = new FileReader()
    reader.readAsDataURL(audioBlob)
    reader.onloadend = () => {
      const base64Audio = reader.result
      const timestamp = Date.now() // Unique key for this message
      const audioMessage = {
        content: base64Audio,
        type: 'audio',
        fileName: `audio_${timestamp}.webm`
      }

      // Send the message
      handleSentMssage('audio', audioMessage)

      // Set duration based on recording time
      setAudioDuration(prev => ({
        ...prev,
        [timestamp]: duration
      }))
    }
  }

  useEffect(() => {
    const messageView = messageViewRef.current
    if (!messageView) return

    const handleScroll = () => {
      const nearBottom =
        Math.abs(
          messageView.scrollHeight -
            messageView.scrollTop -
            messageView.clientHeight
        ) < 100

      setIsAtBottom(nearBottom)
      setShowScrollToBottom(!nearBottom && messages.length > 4)
    }

    messageView.addEventListener('scroll', handleScroll)
    return () => messageView.removeEventListener('scroll', handleScroll)
  }, [messages.length])

  // scroll behaviour when bottom-btn is present
  const handleScrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }

  useEffect(() => {
    const scrollToBottom = () => {
      const messageView = messageViewRef.current
      if (messageView) {
        messageView.scrollTop = messageView.scrollHeight
      }
    }

    const timeout = setTimeout(scrollToBottom, 100) // Wait for DOM

    return () => clearTimeout(timeout)
  }, [chatId]) // ✅ ONLY on chat open/change

  // phoneNumber handle
  const formatPhoneNumber = phoneNumber => {
    if (!phoneNumber) return ''

    // Handle phone numbers with country code
    if (phoneNumber.startsWith('91') && phoneNumber.length >= 12) {
      return `+${phoneNumber.substring(0, 2)} ${phoneNumber.substring(
        2,
        7
      )} ${phoneNumber.substring(7)}`
    }

    // For other formats or shorter numbers, add basic formatting
    if (phoneNumber.length === 10) {
      return `${phoneNumber.substring(0, 5)}-${phoneNumber.substring(5)}`
    }
    return phoneNumber
  }

  // autoomplete the suggestion
  const replaceCurrentWord = suggestion => {
    // Close the suggestion modal regardless
    setShow(false)
    setShowsuggestion(false)

    // Check if the suggestion does NOT start with '@'
    if (suggestion.charAt(0) !== '@') {
      // Immediately send the suggestion as a message
      // Reset the newMessage state before sending if necessary.
      setNewMessage('')
      // Call your existing function to send a text message directly.
      // For example, if you use handleSentMssage for sending messages:
      handleSentMssage('text', { content: suggestion, type: 'text' })
    } else {
      // Otherwise, just append the suggestion to the textarea
      const words = newMessage.split(' ')
      if (words.length > 0) {
        words[words.length - 1] = suggestion
        setNewMessage(words.join(' '))
      } else {
        setNewMessage(suggestion)
      }
      setIsUserTyping(true)
    }
  }

  const handleToggle = () => {
    setShowsuggestion(!showsuggestion)
  }

  const CallingInitiate = type => {
    setCallDetails(type)
    setShowCallModal('calling')
  }

  const handleTouchStart = (e, message) => {
    setTouchStartX(e.touches[0].clientX)
    setTouchStartY(e.touches[0].clientY)
    setTouchMoveX(null)
    setTouchMoveY(null)
    setSwipedMessage(message)
    setLockedAxis(null) // Reset axis lock
  }

  const handleTouchMove = e => {
    if (touchStartX !== null && touchStartY !== null) {
      const newTouchMoveX = e.touches[0].clientX
      const newTouchMoveY = e.touches[0].clientY
      setTouchMoveX(newTouchMoveX)
      setTouchMoveY(newTouchMoveY)

      // Lock the axis if not already locked
      if (!lockedAxis) {
        const deltaX = Math.abs(newTouchMoveX - touchStartX)
        const deltaY = Math.abs(newTouchMoveY - touchStartY)
        setLockedAxis(deltaX > deltaY ? 'x' : 'y')
      }
    }
  }

  const handleTouchEnd = () => {
    if (
      touchStartX !== null &&
      touchMoveX !== null &&
      touchStartY !== null &&
      touchMoveY !== null &&
      swipedMessage &&
      lockedAxis === 'x' // Only trigger reply if X-axis was dominant
    ) {
      const deltaX = touchMoveX - touchStartX
      if (deltaX < -50) {
        // Left swipe threshold (-50px)
        setReplyingTo(swipedMessage)
      }
    }
    setTouchStartX(null)
    setTouchMoveX(null)
    setTouchStartY(null)
    setTouchMoveY(null)
    setSwipedMessage(null)
    setLockedAxis(null)
  }

  // Handle text selection in the textarea
  const handleSelection = () => {
    const textarea = textareaRef.current
    if (textarea) {
      const start = textarea.selectionStart
      const end = textarea.selectionEnd
      setSelection({ start, end })

      // Show toolbar if text is selected
      if (start !== end) {
        setShowToolbar(true)

        // Calculate the position of the toolbar
        const textareaRect = textarea.getBoundingClientRect()
        const lineHeight = parseInt(getComputedStyle(textarea).lineHeight, 10)
        const charWidth = 2 // Approximate character width in pixels (you may need to adjust this)
        const selectedText = newMessage.substring(start, end)
        const lines = selectedText.split('\n').length
        const avgLineLength = selectedText.length / lines

        const top = textareaRect.top - 40 // Position above the textarea
        const left =
          textareaRect.left +
          start * charWidth -
          (avgLineLength * charWidth) / 2

        setToolbarPosition({ top, left })
      } else {
        setShowToolbar(false)
      }
    }
  }

  // Apply markdown formatting to the selected text
  const applyFormatting = format => {
    const textarea = textareaRef.current
    if (!textarea) return

    const { start, end } = selection
    const selectedText = newMessage.substring(start, end)
    let formattedText = selectedText

    switch (format) {
      case 'bold':
        formattedText = `**${selectedText}**`
        break
      case 'italic':
        formattedText = `*${selectedText}*`
        break
      case 'code':
        formattedText = `\`${selectedText}\``
        break
      case 'strikethrough':
        formattedText = `~~${selectedText}~~`
        break
      case 'unordered-list':
        formattedText = selectedText
          .split('\n')
          .map(line => `- ${line}`)
          .join('\n')
        break
      case 'ordered-list':
        formattedText = selectedText
          .split('\n')
          .map((line, index) => `${index + 1}. ${line}`)
          .join('\n')
        break
      case 'quote':
        formattedText = selectedText
          .split('\n')
          .map(line => `> ${line}`)
          .join('\n')
        break
      default:
        break
    }

    const newText =
      newMessage.substring(0, start) + formattedText + newMessage.substring(end)

    setNewMessage(newText)
    setIsUserTyping(newText.trim().length > 0)
    setShowToolbar(false)

    // Restore focus to the textarea
    textarea.focus()
    textarea.setSelectionRange(
      start + formattedText.length,
      start + formattedText.length
    )
  }

  // Toolbar Component
  const MarkdownToolbar = () => (
    <div
      style={{
        position: 'fixed',
        top: toolbarPosition.top,
        left: toolbarPosition.left,
        backgroundColor: '#333',
        borderRadius: '5px',
        padding: '5px',
        display: 'flex',
        gap: '5px',
        zIndex: 1000
      }}
    >
      <Button
        variant="dark"
        size="sm"
        onClick={() => applyFormatting('bold')}
        title="Bold"
      >
        <TypeBold />
      </Button>
      <Button
        variant="dark"
        size="sm"
        onClick={() => applyFormatting('italic')}
        title="Italic"
      >
        <TypeItalic />
      </Button>
      <Button
        variant="dark"
        size="sm"
        onClick={() => applyFormatting('code')}
        title="Code"
      >
        <Code />
      </Button>
      <Button
        variant="dark"
        size="sm"
        onClick={() => applyFormatting('strikethrough')}
        title="Strikethrough"
      >
        <span style={{ textDecoration: 'line-through' }}>S</span>
      </Button>
      <Button
        variant="dark"
        size="sm"
        onClick={() => applyFormatting('unordered-list')}
        title="Unordered List"
      >
        <ListUl />
      </Button>
      <Button
        variant="dark"
        size="sm"
        onClick={() => applyFormatting('ordered-list')}
        title="Ordered List"
      >
        <ListOl />
      </Button>
      <Button
        variant="dark"
        size="sm"
        onClick={() => applyFormatting('quote')}
        title="Quote"
      >
        <Quote />
      </Button>
    </div>
  )

  const getReplyBubblePreview = message => {
    if (!message) return { text: 'Message not found', icon: null }

    const { type, content } = message

    switch (type) {
      case 'text':
        return {
          text:
            content.length > 50 ? content.substring(0, 50) + '...' : content,
          icon: null
        }

      case 'file':
        const isImage = content?.match(/\.(png|jpg|jpeg|gif|svg|webp)$/i)
        const isPdf = content?.match(/\.pdf$/i)
        const isDoc = content?.match(/\.(doc|docx)$/i)
        const isExcel = content?.match(/\.(xls|xlsx)$/i)
        const isText = content?.match(/\.txt$/i)

        if (isImage) return { text: 'Image', icon: <Image size={14} /> }
        if (isPdf) return { text: 'PDF', icon: <FilePdf size={14} /> }
        if (isDoc) return { text: 'Document', icon: <FiletypeDoc size={14} /> }
        if (isExcel)
          return { text: 'Spreadsheet', icon: <FiletypeXlsx size={14} /> }
        if (isText) return { text: 'Text File', icon: <FileText size={14} /> }
        return { text: 'File', icon: <File size={14} /> }

      case 'location':
        return {
          text: 'Location',
          icon: (
            <ion-icon
              name="location-outline"
              style={{ fontSize: '14px' }}
            ></ion-icon>
          )
        }

      case 'sticker':
        return { text: 'Sticker', icon: <Sticker size={14} /> }

      case 'poll':
        return {
          text: 'Poll',
          icon: (
            <ion-icon
              name="stats-chart-outline"
              style={{ fontSize: '14px' }}
            ></ion-icon>
          )
        }

      case 'link':
        return {
          text: 'Link',
          icon: (
            <ion-icon
              name="link-outline"
              style={{ fontSize: '14px' }}
            ></ion-icon>
          )
        }

      case 'audio':
        return { text: 'Audio', icon: <Mic size={14} /> }

      case 'call':
        return { text: 'Call', icon: <PhoneOff size={14} /> }

      case 'emoji':
        return { text: 'Emoji', icon: <EmojiSmileFill size={14} /> }

      default:
        return { text: 'Message', icon: null }
    }
  }

  const scrollToMessage = replyToUuid => {
    // Ensure replyToUuid is valid
    if (!replyToUuid) {
      console.warn('No replyTo UUID provided')
      return
    }

    // Find the message in the messages state to confirm it exists
    const repliedMessage = messages.find(msg => msg.uuid === replyToUuid)
    if (!repliedMessage) {
      console.warn(`Message with UUID ${replyToUuid} not found in messages`)
      return
    }

    // Use setTimeout to ensure DOM is updated
    setTimeout(() => {
      const repliedMessageElement = document.querySelector(
        `[data-message-uuid="${replyToUuid}"]`
      )
      if (repliedMessageElement) {
        repliedMessageElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
        // Add temporary highlight
        repliedMessageElement.style.transition = 'background-color 0.3s'
        repliedMessageElement.style.backgroundColor = 'antiquewhite'
        setTimeout(() => {
          repliedMessageElement.style.backgroundColor = ''
        }, 1000)
      } else {
        console.warn(`DOM element for message UUID ${replyToUuid} not found`)
      }
    }, 0) // Delay to ensure DOM updates
  }

  const renderMessageStatus = (message, isLoggedUser) => {
    if (!isLoggedUser) return null
    // console.log(
    //   'Status Render for:',
    //   message.content,
    //   message.status,
    //   message.source
    // )

    if (
      message?.source === 'local' ||
      message.status === 'pending' ||
      message.status === 'sending'
    ) {
      return (
        <Clock3
          style={{
            width: '10px',
            height: '10px',
            color:
              message.type === 'sticker' || message.type === 'emoji'
                ? '#000'
                : '#fff'
          }}
          aria-label="Message pending or sending"
        />
      )
    }

    return (
      <Check
        style={{
          width: '10px',
          height: '10px',
          color:
            message.type === 'sticker' || message.type === 'emoji'
              ? '#000'
              : '#fff'
        }}
        aria-label="Message sent"
      />
    )
  }

  // Send message to iframe
  useEffect(() => {
    if (showIframe && iframeRef.current) {
      const iframe = iframeRef.current

      const handleLoad = () => {
        console.log('Iframe loaded, sending message...')
        iframe.contentWindow.postMessage(
          { chat: selectedChat },
          'https://skyq.tech'
        )
      }

      iframe.addEventListener('load', handleLoad)

      return () => {
        iframe.removeEventListener('load', handleLoad)
      }
    }
  }, [showIframe, selectedChat])

  // Receive message from iframe
  useEffect(() => {
    const handleMessage = event => {
      // console.log('Received from iframe:', event.data)
      if (event.data && event.data.message) {
        setReceivedMessage(event.data.message)
        // Directly send the message using handleSentMssage
        const textMessage = {
          content: event.data.message,
          type: 'text'
        }
        handleSentMssage('text', textMessage)
      } else {
        setReceivedMessage('Invalid message format')
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [handleSentMssage]) // Add handleSentMssage as a dependency

  useEffect(() => {
    if (window?.plugins && window?.plugins?.insomnia) {
      if (showIframe) {
        window?.plugins?.insomnia.keepAwake()
      } else {
        window?.plugins?.insomnia.allowSleepAgain()
      }
    }

    // Optional cleanup if needed
    return () => {
      window?.plugins?.insomnia.allowSleepAgain()
    }
  }, [showIframe])

  useEffect(() => {
    if (!chatThreads || !user || !messages.length) {
      setShowUnreadBadge(false)
      setUnreadCount(0)
      setFirstUnreadMessage(null)
      return
    }

    const currentUserInChat = chatThreads.users.find(u => u._id === user._id)
    const lastSeen = currentUserInChat?.lastSeen
      ? new Date(currentUserInChat.lastSeen)
      : new Date(0)

    const unreadMessages = messages.filter(
      msg =>
        new Date(msg.createdAt) > lastSeen &&
        msg.sender &&
        msg.sender._id !== user._id
    )
    setUnreadCount(unreadMessages.length)
    setFirstUnreadMessage(unreadMessages[0] || null)
    setShowUnreadBadge(unreadMessages.length > 0)
  }, [messages, chatThreads, user])

  return (
    <>
      <div class="chatHeader">
        <div className="d-flex align-items-center w-100">
          <Link
            to="/dashboard"
            onClick={() => setReplyingTo(null)}
            className="btn btn-outline-primary outline-none border-0 btn-sm px-0 d-flex align-items-center justify-content-center d-sm-none"
          >
            <ion-icon
              name="arrow-back-outline"
              style={{ color: '#000' }}
            ></ion-icon>
          </Link>
          <div
            className="d-flex align-items-center gap-1 position-relative w-100"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              if (chatThreads) {
                if (chatThreads.isGroupChat) {
                  // Navigate to profile with group details
                  navigate(`/profile`, { state: { group: chatThreads } })
                } else {
                  // Find the other user (not the current user) in the chat
                  const otherUser = chatThreads.users.find(
                    u => u._id !== user?._id
                  )
                  if (otherUser) {
                    // Navigate to profile with the other user’s details
                    navigate(`/profile`, { state: { user: otherUser } })
                  }
                }
              }
            }}
          >
            <div
              style={{
                border: socketConnected
                  ? '2px solid #34c759'
                  : '2px solid #ec4433',
                borderRadius: '50%'
              }}
            >
              {chatThreads?.isGroupChat === true ? (
                <>
                  <div
                    className="image d-flex align-items-center justify-content-center col-dry"
                    style={{
                      backgroundColor: '#e0e0e0',
                      borderRadius: '50%'
                    }}
                  >
                    <ion-icon
                      name="people-sharp"
                      style={{ width: '25px', height: '33px' }}
                    ></ion-icon>
                  </div>
                </>
              ) : (
                <img
                  src={chatThreads?.users?.find(u => u._id !== user?._id)?.pic}
                  alt="images"
                  className="image"
                  style={{
                    borderRadius: '50%',
                    aspectRatio: '1/1',
                    objectFit: 'cover'
                  }}
                  onError={e => {
                    e.target.onerror = null // Prevent infinite loop
                    e.target.src =
                      'https://icon-library.com/images/anonymous-avatar-icon/anonymous-avatar-icon-25.jpg' // Fallback image
                  }}
                />
              )}
            </div>
            <label className="mb-2">
              {
                chatThreads?.isGroupChat
                  ? chatThreads.chatName // Show group name if it's a group chat
                  : chatThreads?.users?.find(u => u._id !== user?._id)?.name // Show other user's name for 1-on-1 chat
              }
            </label>
            <span
              className="text-muted "
              style={{ position: 'absolute', bottom: '0px', left: '38px' }}
            >
              {
                chatThreads?.isGroupChat
                  ? chatThreads?.users?.length > 0
                    ? chatThreads.users.length <= 4
                      ? chatThreads.users.map(u => u.name).join(', ')
                      : chatThreads.users
                          .slice(0, 3)
                          .map(u => u.name)
                          .join(', ') + '...'
                    : 'No members available'
                  : chatThreads?.users?.find(u => u._id !== user?._id)?.lastSeen
                  ? moment(
                      chatThreads.users.find(u => u._id !== user?._id)?.lastSeen
                    ).calendar(null, {
                      sameDay: 'hh:mm A', // Show time if last seen today (e.g., 10:30 AM)
                      lastDay: '[Yesterday]', // Show "Yesterday" if last seen yesterday
                      lastWeek: 'dddd', // Show day name if last seen within the last week (e.g., Monday)
                      sameElse: 'MMM D, YYYY' // Show date for older messages (e.g., Aug 25, 2024)
                    })
                  : 'Last seen not available' // Fallback if lastSeen is null
              }
              {/* {console.log(chatThreads)} */}
            </span>
          </div>
        </div>
        {chatThreads?.commands?.length > 0 && (
          <div className="d-flex flex-row gap-1">
            <div className=" d-block d-md-block iframe-btn">
              <Button
                size="sm"
                variant="outline-secondary"
                onClick={handleShowFrame}
                className="me-1"
              >
                <Computer />
              </Button>

              <Modal
                fullscreen
                show={showIframe}
                onHide={handleCloseFrame}
                className="iframe"
              >
                <Modal.Header closeButton>
                  {/* <Modal.Title>Modal heading</Modal.Title> */}
                </Modal.Header>
                <Modal.Body>
                  <iframe
                    ref={iframeRef}
                    src="https://skyq.tech/Demo.html"
                    title="Child Iframe"
                    width="100%"
                    height="100%"
                    style={{ border: '1px solid #ccc' }}
                  />
                </Modal.Body>
              </Modal>
            </div>
            <div className="d-none d-md-block">
              <SquareTerminal
                strokeWidth={1}
                size={30}
                onClick={handleShow}
                style={{ cursor: 'pointer' }}
              />

              <Modal show={show} onHide={handleClose}>
                <Modal.Body>
                  <span className="close-it" onClick={handleClose}>
                    <ion-icon
                      name="close-outline"
                      style={{ fontSize: '25px' }}
                    ></ion-icon>
                  </span>
                  <div
                    className="d-flex align-items-center flex-wrap gap-3 p-2 w-100"
                    style={{ gap: '5px' }}
                  >
                    {chatThreads?.commands.map((v, k) => (
                      <Badge
                        key={k}
                        className="suggest"
                        bg="primary"
                        style={{
                          cursor: 'pointer',
                          height: '30px',
                          minWidth: '35px',
                          fontSize: '14px'
                        }}
                        onClick={() => replaceCurrentWord(v)} // Use the new function here
                      >
                        {v}
                      </Badge>
                    ))}
                  </div>
                </Modal.Body>
              </Modal>
            </div>
            <div className="d-block d-md-none">
              <SquareTerminal
                size={32}
                strokeWidth={1}
                onClick={handleToggle}
                style={{ cursor: 'pointer' }}
              />
              <Offcanvas
                show={showsuggestion}
                onHide={handleToggle}
                placement="bottom"
                className="action-sheet inset ios-add-to-home"
              >
                <Offcanvas.Header>
                  <Offcanvas.Title>Suggested Commands</Offcanvas.Title>
                  <span onClick={handleToggle} className="off-close">
                    <ion-icon name="close"></ion-icon>
                  </span>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <div
                    className="d-flex justify-content-center align-items-center flex-wrap gap-3 p-2 w-100"
                    style={{ gap: '5px' }}
                  >
                    {chatThreads?.commands.map((v, k) => (
                      <Badge
                        key={k}
                        className="suggest px-2"
                        bg="primary"
                        style={{
                          cursor: 'pointer',
                          height: '30px',
                          minWidth: '35px',
                          fontSize: '14px'
                        }}
                        onClick={() => replaceCurrentWord(v)} // Use the new function here
                      >
                        {v}
                      </Badge>
                    ))}
                  </div>
                </Offcanvas.Body>
              </Offcanvas>
            </div>
          </div>
        )}

        {chatThreads?.isGroupChat !== true && (
          <>
            <span
              className="headerCallButton Video"
              onClick={() => CallingInitiate('Video')}
            >
              <ion-icon
                name="videocam-outline"
                role="img"
                class="md hydrated"
                aria-label="videocam outline"
              ></ion-icon>
            </span>

            <span
              className="headerCallButton Audio"
              onClick={() => CallingInitiate('Audio')}
            >
              <ion-icon
                name="call-outline"
                role="img"
                class="md hydrated"
                aria-label="call outline"
              ></ion-icon>
            </span>
          </>
        )}
      </div>

      <div className="position-relative UserChatView">
        {/* message view  */}
        <div className="message-view" ref={messageViewRef}>
          {isLoadingOlderMessages && (
            <div
              className="top-loading-spinner"
              style={{ textAlign: 'center', padding: '10px', zIndex: '100' }}
            >
              <span
                className="spinner-border spinner-border-sm text-primary"
                role="status"
              />
            </div>
          )}

          {Object.keys(groupedMessages).map((date, index) => (
            <div key={index}>
              <div className="message-divider m-1">
                <Badge
                  bg="light"
                  style={{
                    color: '#000',
                    padding: '0.75rem',
                    fontWeight: '600',
                    boxShadow:
                      '0 3px 6px 0 rgba(0, 0, 0, 0.1), 0 1px 3px 0 rgba(0, 0, 0, 0.08)'
                  }}
                >
                  {date}
                </Badge>
              </div>

              {groupedMessages[date]
                .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                .map((v, k, arr) => {
                  const isLoggedUser = v?.sender?._id === user?._id
                  const isFirstMessage =
                    k === 0 || arr[k - 1]?.sender?._id !== v?.sender?._id
                  const showProfile =
                    chatThreads?.isGroupChat && !isLoggedUser && isFirstMessage
                  const isLocationMessage = v.type === 'location'
                  const isImage = v.content?.match(
                    /\.(png|jpg|jpeg|gif|svg|webp)$/i
                  )
                  const isPdf = v.content?.match(/\.pdf$/i)
                  const isDoc = v.content?.match(/\.(doc|docx)$/i)
                  const isExcel = v.content?.match(/\.(xls|xlsx)$/i)
                  const isText = v.content?.match(/\.txt$/i)
                  const fileName = v.content.split('/').pop() || 'unknown-file' // Fallback if split fails
                  let FileName = fileName // Default to raw fileName

                  try {
                    // Only attempt decoding if fileName is a non-empty string and contains URI-encoded characters
                    if (
                      fileName &&
                      typeof fileName === 'string' &&
                      /%[0-9A-Fa-f]{2}/.test(fileName)
                    ) {
                      FileName = decodeURIComponent(fileName)
                    }
                  } catch (error) {
                    console.error('Failed to decode fileName:', fileName, error)
                    FileName = fileName // Fallback to raw fileName on error
                  }
                  // Calculate transform based on locked axis
                  const transform =
                    swipedMessage?._id === v._id &&
                    touchStartX &&
                    touchMoveX &&
                    touchStartY &&
                    touchMoveY
                      ? lockedAxis === 'x'
                        ? `translateX(${Math.max(
                            touchMoveX - touchStartX,
                            -50
                          )}px)` // Slide left only
                        : 'translateX(0)' // No sliding if Y-axis dominates
                      : 'translateX(0)'
                  const isAudio = v.type === 'audio' // Check for audio type
                  // Check if this is the first unread message
                  const isFirstUnread =
                    firstUnreadMessage &&
                    (v.uuid === firstUnreadMessage.uuid ||
                      v._id === firstUnreadMessage._id)

                  return (
                    <>
                      {isFirstUnread && showUnreadBadge && (
                        <div className="message-divider m-1">
                          <Badge
                            bg="secondary"
                            style={{
                              color: '#fff',
                              padding: '0.75rem',
                              fontWeight: '600',
                              boxShadow:
                                '0 3px 6px 0 rgba(0, 0, 0, 0.1), 0 1px 3px 0 rgba(0, 0, 0, 0.08)'
                            }}
                          >
                            {unreadCount} New &nbsp;
                            {unreadCount === 1 ? 'Message' : 'Messages'}
                          </Badge>
                        </div>
                      )}
                      <div
                        key={v.uuid}
                        className={
                          isLoggedUser ? 'message-item user' : 'message-item'
                        }
                        style={{
                          marginTop: '-5px'
                        }}
                        onTouchStart={e => handleTouchStart(e, v)} // Pass the message
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        data-message-uuid={v.uuid}
                        ref={isFirstUnread ? firstUnreadRef : null} // Attach ref to first unread message
                      >
                        {showProfile && chatId === v?.chat?._id && (
                          <img
                            src="https://icon-library.com/images/anonymous-avatar-icon/anonymous-avatar-icon-25.jpg"
                            alt="User"
                            className="chat-profile-pic"
                            style={{
                              width: '28px',
                              height: '28px',
                              borderRadius: '50%',
                              marginBottom: v.type === 'sticker' ? '20px' : '',
                              objectFit: 'cover'
                            }}
                            onClick={() =>
                              navigate('/profile', {
                                state: { user: v.sender }
                              })
                            }
                          />
                        )}
                        <div
                          className="content"
                          style={{
                            marginLeft:
                              chatThreads?.isGroupChat && !isFirstMessage
                                ? '1.9rem'
                                : '0px',
                            transition: 'transform 0.1s ease-out',
                            transform // Apply swipe transform
                          }}
                        >
                          <div
                            className={
                              isLoggedUser
                                ? 'message-item user d-flex flex-row-reverse align-items-center'
                                : 'message-item d-flex align-items-center'
                            }
                          >
                            {v.type === 'sticker' ? (
                              <div
                                className="bubble d-flex flex-column"
                                style={{
                                  background:
                                    v.type === 'sticker' ? 'transparent' : '',
                                  boxShadow: v.type === 'sticker' ? 'none' : '',
                                  padding: v.type === 'sticker' ? '0' : '10px'
                                }}
                              >
                                {showProfile && isFirstMessage && (
                                  <div
                                    className="title p-1 rounded-pill"
                                    style={{
                                      cursor: 'pointer',
                                      backgroundColor: '#ffffff',
                                      maxWidth: '100px',
                                      width: 'fit-content',
                                      marginBottom: '3px',
                                      marginLeft: showProfile ? '0' : '45px',
                                      color: isDark
                                        ? '#fff'
                                        : isLoggedUser
                                        ? '#fff'
                                        : '#000'
                                    }}
                                    onClick={() =>
                                      navigate('/profile', {
                                        state: { user: v.sender }
                                      })
                                    }
                                  >
                                    <b
                                      style={{
                                        fontWeight: '600'
                                      }}
                                    >
                                      {(() => {
                                        const senderUser =
                                          chatThreads?.users?.find(
                                            u => u._id === v.sender._id
                                          )
                                        return senderUser
                                          ? senderUser.type === 'bot'
                                            ? senderUser.display ||
                                              senderUser.name ||
                                              'Unknown'
                                            : senderUser.name || 'Unknown'
                                          : v.sender?.name || 'Unknown'
                                      })()}
                                    </b>
                                  </div>
                                )}
                                <div className="d-flex flex-column align-items-end">
                                  <img
                                    src={v.content}
                                    alt="Sticker"
                                    className="sticker-msg"
                                    style={{
                                      width: '200px',
                                      height: '200px',
                                      borderRadius: '10px'
                                    }}
                                    onError={e => {
                                      e.target.onerror = null // Prevent infinite loop
                                      e.target.src =
                                        'https://icon-library.com/images/anonymous-avatar-icon/anonymous-avatar-icon-25.jpg' // Fallback image
                                    }}
                                  />
                                  <div
                                    className="d-flex flex-row align-items-end"
                                    style={{
                                      columnGap: '7px',
                                      height: '16px'
                                    }}
                                  >
                                    <span
                                      className="time1"
                                      style={{
                                        fontSize: '9.5px',
                                        position: 'relative',
                                        top: '0.4rem',
                                        height: 'fit-content',
                                        color: '#000000'
                                      }}
                                    >
                                      {v.createdAt
                                        ? moment(v.createdAt).format('hh:mm A')
                                        : 'N/A'}
                                    </span>
                                    {renderMessageStatus(v, isLoggedUser)}
                                  </div>
                                </div>
                              </div>
                            ) : v.type === 'emoji' ? (
                              <>
                                <div
                                  className="bubble d-flex flex-column align-items-end my-1"
                                  style={{
                                    background:
                                      v.type === 'emoji' ? 'transparent' : '',
                                    boxShadow: v.type === 'emoji' ? 'none' : '',
                                    padding: v.type === 'emoji' ? '0' : '10px'
                                  }}
                                >
                                  {showProfile && isFirstMessage && (
                                    <div
                                      className="title p-1 rounded-pill"
                                      style={{
                                        cursor: 'pointer',
                                        backgroundColor: '#ffffff',
                                        maxWidth: '100px',
                                        width: 'fit-content',
                                        marginBottom: '3px',
                                        marginLeft: showProfile ? '0' : '45px'
                                      }}
                                      onClick={() =>
                                        navigate('/profile', {
                                          state: { user: v.sender }
                                        })
                                      }
                                    >
                                      <b style={{ fontWeight: '600' }}>
                                        {(() => {
                                          const senderUser =
                                            chatThreads?.users?.find(
                                              u => u._id === v.sender._id
                                            )
                                          return senderUser
                                            ? senderUser.type === 'bot'
                                              ? senderUser.display ||
                                                senderUser.name ||
                                                'Unknown'
                                              : senderUser.name || 'Unknown'
                                            : v.sender?.name || 'Unknown'
                                        })()}
                                      </b>
                                    </div>
                                  )}
                                  <div className="d-flex flex-column align-items-end">
                                    <span
                                      className="d-flex align-items-center justify-content-center"
                                      style={{
                                        flex: '1 1 auto',
                                        width: '80px',
                                        height: '80px',
                                        fontSize: '60px'
                                      }}
                                    >
                                      {v.content}
                                    </span>
                                  </div>
                                  <div
                                    className="d-flex flex-row align-items-end"
                                    style={{
                                      columnGap: '7px',
                                      height: '16px'
                                    }}
                                  >
                                    <span
                                      className="time1"
                                      style={{
                                        fontSize: '9.5px',
                                        position: 'relative',
                                        top: '0.4rem',
                                        height: 'fit-content',
                                        color: '#000000'
                                      }}
                                    >
                                      {v.createdAt
                                        ? moment(v.createdAt).format('hh:mm A')
                                        : 'N/A'}
                                    </span>
                                    {renderMessageStatus(v, isLoggedUser)}
                                  </div>
                                </div>
                              </>
                            ) : isAudio ? (
                              <div
                                className="bubble d-flex flex-column align-items-end"
                                style={{
                                  background: isAudio ? 'transparent' : '',
                                  boxShadow: isAudio ? 'none' : '',
                                  padding: isAudio ? '0' : '10px'
                                }}
                              >
                                {showProfile && isFirstMessage && (
                                  <div
                                    className="title p-1 rounded-pill"
                                    style={{
                                      cursor: 'pointer',
                                      backgroundColor: '#ffffff',
                                      maxWidth: '100px',
                                      width: 'fit-content',
                                      marginBottom: '3px',
                                      marginLeft: showProfile ? '0' : '45px'
                                    }}
                                    onClick={() =>
                                      navigate('/profile', {
                                        state: { user: v.sender }
                                      })
                                    }
                                  >
                                    <b style={{ fontWeight: '600' }}>
                                      {(() => {
                                        const senderUser =
                                          chatThreads?.users?.find(
                                            u => u._id === v.sender._id
                                          )
                                        return senderUser
                                          ? senderUser.type === 'bot'
                                            ? senderUser.display ||
                                              senderUser.name ||
                                              'Unknown'
                                            : senderUser.name || 'Unknown'
                                          : v.sender?.name || 'Unknown'
                                      })()}
                                    </b>
                                  </div>
                                )}
                                {/* Custom Audio Player */}
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    maxWidth: '260px',
                                    backgroundColor: isLoggedUser
                                      ? '#272626'
                                      : '#6969698a',
                                    padding: '5px 5px',
                                    borderRadius: '8px'
                                  }}
                                >
                                  {/* Hidden Audio Element for Playback */}
                                  <audio
                                    ref={el => {
                                      if (
                                        el &&
                                        !audioRefs.current[v.createdAt]
                                      ) {
                                        audioRefs.current[v.createdAt] = el
                                      }
                                    }}
                                    src={v.content}
                                    preload="metadata"
                                    onTimeUpdate={e => {
                                      const audio = e.target
                                      setAudioProgress(prev => ({
                                        ...prev,
                                        [v.createdAt]: audio.currentTime
                                      }))
                                    }}
                                    onEnded={() => {
                                      setAudioPlaying(prev => ({
                                        ...prev,
                                        [v.createdAt]: false
                                      }))
                                      setAudioProgress(prev => ({
                                        ...prev,
                                        [v.createdAt]: 0
                                      }))
                                    }}
                                  />
                                  <Button
                                    variant="link"
                                    size="sm"
                                    style={{
                                      padding: 0,
                                      width: '30px',
                                      color: isLoggedUser ? '#fff' : '#000'
                                    }}
                                    onClick={() => {
                                      const audio =
                                        audioRefs.current[v.createdAt]
                                      if (audioPlaying[v.createdAt]) {
                                        audio.pause()
                                        setAudioPlaying(prev => ({
                                          ...prev,
                                          [v.createdAt]: false
                                        }))
                                      } else {
                                        audio
                                          .play()
                                          .catch(err =>
                                            console.error(
                                              'Playback error:',
                                              err
                                            )
                                          )
                                        setAudioPlaying(prev => ({
                                          ...prev,
                                          [v.createdAt]: true
                                        }))
                                      }
                                    }}
                                  >
                                    {audioPlaying[v.createdAt] ? (
                                      <ion-icon
                                        name="pause-outline"
                                        style={{
                                          fontSize: '24px',
                                          color: isLoggedUser ? '#fff' : '#000'
                                        }}
                                      ></ion-icon>
                                    ) : (
                                      <ion-icon
                                        name="play-outline"
                                        style={{
                                          fontSize: '24px',
                                          color: isLoggedUser ? '#fff' : '#000'
                                        }}
                                      ></ion-icon>
                                    )}
                                  </Button>
                                  <input
                                    type="range"
                                    min="0"
                                    max={audioDuration[v.createdAt] || 0} // Use recordingTime-based duration
                                    value={audioProgress[v.createdAt] || 0}
                                    onChange={e => {
                                      const newTime = parseFloat(e.target.value)
                                      const audio =
                                        audioRefs.current[v.createdAt]
                                      audio.currentTime = newTime
                                      setAudioProgress(prev => ({
                                        ...prev,
                                        [v.createdAt]: newTime
                                      }))
                                    }}
                                    style={{
                                      flex: 1,
                                      height: '5px',
                                      cursor: 'pointer'
                                    }}
                                  />
                                  <span
                                    className="px-1"
                                    style={{
                                      fontSize: '12px',
                                      color: isLoggedUser ? '#fff' : '#000'
                                    }}
                                  >
                                    {formatTime(
                                      audioPlaying[v.createdAt]
                                        ? audioProgress[v.createdAt] || 0
                                        : audioDuration[v.createdAt] || 0
                                    )}
                                  </span>
                                </div>
                                {/* Time and Status */}
                                <div
                                  className="rounded-pill d-flex flex-row align-items-end px-1"
                                  style={{
                                    columnGap: '7px',
                                    height: '16px',
                                    marginTop: '1px',
                                    paddingBottom: '4px',
                                    backgroundColor: isLoggedUser
                                      ? '#272626'
                                      : '#6969698a'
                                  }}
                                >
                                  <span
                                    className="time1"
                                    style={{
                                      fontSize: '9.5px',
                                      position: 'relative',
                                      top: '0.4rem',
                                      height: 'fit-content',
                                      color: isLoggedUser ? '#fff' : '#000000'
                                    }}
                                  >
                                    {v.createdAt
                                      ? moment(v.createdAt).format('hh:mm A')
                                      : 'N/A'}
                                  </span>
                                  {renderMessageStatus(v, isLoggedUser)}
                                </div>
                              </div>
                            ) : (
                              <div
                                className="bubble d-flex flex-column gap-1"
                                style={{
                                  wordWrap: 'break-word',
                                  overflowWrap: 'break-word',
                                  borderRadius: !isFirstMessage && '6px ',
                                  marginTop: !isFirstMessage && '0px'
                                }}
                              >
                                {showProfile && isFirstMessage && (
                                  <div
                                    className="title"
                                    style={{
                                      cursor: 'pointer',
                                      marginLeft: showProfile ? '0' : '45px'
                                    }}
                                    onClick={() =>
                                      navigate('/profile', {
                                        state: { user: v.sender }
                                      })
                                    }
                                  >
                                    <b style={{ fontWeight: '600' }}>
                                      {(() => {
                                        const senderUser =
                                          chatThreads?.users?.find(
                                            u => u._id === v.sender._id
                                          )
                                        return senderUser
                                          ? senderUser.type === 'bot'
                                            ? senderUser.display ||
                                              senderUser.name ||
                                              'Unknown'
                                            : senderUser.name || 'Unknown'
                                          : v.sender?.name || 'Unknown'
                                      })()}
                                    </b>
                                  </div>
                                )}
                                <div
                                  className="msg"
                                  style={{ maxWidth: 'fit-content' }}
                                >
                                  {v.replyTo && (
                                    <div
                                      style={{
                                        backgroundColor: '#e9ecef',
                                        padding: '5px 10px',
                                        borderRadius: '5px',
                                        marginBottom: '5px',
                                        fontSize: '12px',
                                        borderLeft: '3px solid #007bff', // WhatsApp-like styling
                                        cursor: 'pointer' // Indicate clickable
                                      }}
                                      onClick={() => scrollToMessage(v.replyTo)}
                                    >
                                      {/* Fetch sender name from chat users or assume it's available */}
                                      {(() => {
                                        const repliedMessage = messages.find(
                                          msg => msg.uuid === v.replyTo
                                        )
                                        return (
                                          <>
                                            <div>
                                              {repliedMessage ? (
                                                <b className="fw-bolder">
                                                  {(() => {
                                                    const senderUser =
                                                      chatThreads?.users?.find(
                                                        u =>
                                                          u._id ===
                                                          repliedMessage.sender
                                                            ._id
                                                      )
                                                    return senderUser
                                                      ? senderUser.type ===
                                                        'bot'
                                                        ? senderUser.display ||
                                                          senderUser.name ||
                                                          'Unknown'
                                                        : senderUser.name ||
                                                          'Unknown'
                                                      : repliedMessage.sender
                                                          ?.name || 'Unknown'
                                                  })()}
                                                </b>
                                              ) : (
                                                <i>Loading Name</i>
                                              )}
                                            </div>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '5px'
                                              }}
                                            >
                                              {repliedMessage &&
                                                getReplyBubblePreview(
                                                  repliedMessage
                                                ).icon}
                                              <span>
                                                {repliedMessage
                                                  ? getReplyBubblePreview(
                                                      repliedMessage
                                                    ).text
                                                  : 'Message not found'}
                                              </span>
                                            </div>
                                          </>
                                        )
                                      })()}
                                    </div>
                                  )}
                                  {/* Link and Text msg */}
                                  {v.type === 'link' ? (
                                    <>
                                      <div className="link-preview">
                                        <LinkPreviewWithText
                                          content={v.content}
                                          isLoggedUser={isLoggedUser}
                                        />
                                        <div
                                          className="d-flex flex-row align-items-end justify-content-end"
                                          style={{
                                            columnGap: '7px',
                                            height: '16px'
                                          }}
                                        >
                                          <span
                                            className="time"
                                            style={{
                                              fontSize: '9.5px',
                                              position: 'relative',
                                              top: '0.4rem',
                                              height: 'fit-content'
                                            }}
                                          >
                                            {v.createdAt
                                              ? moment(v.createdAt).format(
                                                  'hh:mm A'
                                                )
                                              : 'N/A'}
                                          </span>
                                          {renderMessageStatus(v, isLoggedUser)}
                                        </div>
                                      </div>
                                    </>
                                  ) : v.type === 'call' ? (
                                    <>
                                      <CallingBubble
                                        content={v}
                                        isLoggedUser={isLoggedUser}
                                        // CallingInitiate={CallingInitiate}
                                      />
                                      <div
                                        className="d-flex flex-row align-items-end justify-content-end"
                                        style={{
                                          columnGap: '7px',
                                          height: '16px'
                                        }}
                                      >
                                        <span
                                          className="time"
                                          style={{
                                            fontSize: '9.5px',
                                            position: 'relative',
                                            top: '0.4rem',
                                            height: 'fit-content'
                                          }}
                                        >
                                          {v.createdAt
                                            ? moment(v.createdAt).format(
                                                'hh:mm A'
                                              )
                                            : 'N/A'}
                                        </span>
                                        {renderMessageStatus(v, isLoggedUser)}
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      {isImage || isPdf || isDoc || isText ? (
                                        <div className="d-flex flex-column align-items-end">
                                          {isImage ? (
                                            <a
                                              href={v.content}
                                              rel="noopener noreferrer"
                                              style={{
                                                color: isLoggedUser
                                                  ? '#fff'
                                                  : '#0000EE'
                                              }}
                                            >
                                              <img
                                                src={v.content}
                                                alt={fileName}
                                                style={{
                                                  maxWidth: '270px',
                                                  borderRadius: '8px',
                                                  marginBottom: '5px'
                                                }}
                                              />
                                            </a>
                                          ) : (
                                            <div className="d-flex flex-column align-items-center gap-1">
                                              <span
                                                style={{
                                                  width: 'fit-content',
                                                  height: 'fit-content',
                                                  color: isLoggedUser
                                                    ? '#fff'
                                                    : '#000',
                                                  marginTop: '4px'
                                                }}
                                              >
                                                {isPdf ? (
                                                  <FilePdf size={42} />
                                                ) : isDoc ? (
                                                  <FiletypeDoc size={42} />
                                                ) : isExcel ? (
                                                  <FiletypeXlsx size={42} />
                                                ) : isText ? (
                                                  <FileText size={42} />
                                                ) : (
                                                  <FileEarmark size={42} />
                                                )}
                                              </span>
                                              <p
                                                className="mt-1 mb-0"
                                                style={{
                                                  color: isLoggedUser
                                                    ? '#ffffff'
                                                    : '#000000'
                                                }}
                                              >
                                                {FileName}
                                              </p>
                                              {!isLoggedUser && (
                                                <>
                                                  <hr
                                                    className="my-1"
                                                    style={{
                                                      color: isLoggedUser
                                                        ? '#fff'
                                                        : '#000',
                                                      width: '100%'
                                                    }}
                                                  />
                                                  <Button
                                                    variant="link w-100 file"
                                                    style={{
                                                      border: '1px solid #000',
                                                      backgroundColor:
                                                        '#c6c6c6',
                                                      color: '#000'
                                                    }}
                                                  >
                                                    <a
                                                      href={v.content}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                      style={{
                                                        color: '#000'
                                                      }}
                                                    >
                                                      Download
                                                    </a>
                                                  </Button>
                                                </>
                                              )}
                                            </div>
                                          )}
                                          {/* time and status */}
                                          <div
                                            className="d-flex flex-row align-items-end"
                                            style={{
                                              columnGap: '7px',
                                              height: '16px'
                                            }}
                                          >
                                            <span
                                              className="time"
                                              style={{
                                                fontSize: '9.5px',
                                                position: 'relative',
                                                top: '0.4rem',
                                                height: 'fit-content'
                                              }}
                                            >
                                              {v.createdAt
                                                ? moment(v.createdAt).format(
                                                    'hh:mm A'
                                                  )
                                                : 'N/A'}
                                            </span>
                                            {renderMessageStatus(
                                              v,
                                              isLoggedUser
                                            )}
                                          </div>
                                        </div>
                                      ) : (
                                        <div
                                          className="message-content d-flex flex-column gap-1"
                                          style={{
                                            wordWrap: 'break-word',
                                            overflowWrap: 'break-word',
                                            columnGap: '0.7rem',
                                            display: 'flex',
                                            alignItems: 'flex-end'
                                          }}
                                        >
                                          {v.mapPreview ? (
                                            <a
                                              href={v.content}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              style={{
                                                color: isLoggedUser
                                                  ? '#ffffff'
                                                  : '#0000EE',
                                                textDecoration: 'underline',
                                                display: 'block',
                                                fontWeight: '500'
                                              }}
                                            >
                                              {v.mapPreview && (
                                                <div className="map-container">
                                                  <img
                                                    src={v.mapPreview}
                                                    className="map-image"
                                                    alt="Location Preview"
                                                    style={{
                                                      borderRadius: '8px',
                                                      marginTop: '5px',
                                                      maxWidth: '100%'
                                                    }}
                                                    onError={e => {
                                                      e.target.onerror = null // Prevent infinite loop
                                                      e.target.src =
                                                        'https://icon-library.com/images/anonymous-avatar-icon/anonymous-avatar-icon-25.jpg' // Fallback image
                                                    }}
                                                  />
                                                  <div
                                                    className="map-marker"
                                                    style={{
                                                      left: '50%',
                                                      top: '50%'
                                                    }}
                                                  >
                                                    <ion-icon
                                                      name="location-sharp"
                                                      style={{
                                                        color: 'red'
                                                      }}
                                                    ></ion-icon>
                                                  </div>
                                                </div>
                                              )}
                                            </a>
                                          ) : (
                                            <>
                                              {/* <span
                                                style={{
                                                  flex: '1 1 auto',
                                                  maxWidth: '200px',
                                                  width: '100%',
                                                  color: isLoggedUser
                                                    ? '#ffffff'
                                                    : '#000'
                                                }}
                                              >
                                                <ReactMarkdown
                                                  components={{
                                                    p: ({ node, ...props }) => (
                                                      <p
                                                        style={{
                                                          color: isLoggedUser
                                                            ? '#ffffff'
                                                            : '#000',
                                                          margin: '0'
                                                        }}
                                                        {...props}
                                                      />
                                                    ),
                                                    strong: ({
                                                      node,
                                                      ...props
                                                    }) => (
                                                      <strong
                                                        style={{
                                                          color: isLoggedUser
                                                            ? '#ffffff'
                                                            : '#000',
                                                          fontWeight: 600
                                                        }}
                                                        {...props}
                                                      />
                                                    )
                                                  }}
                                                >
                                                  {v.content}
                                                </ReactMarkdown>
                                              </span> */}
                                              {/* sceond wala */}
                                              <span
                                                className="text-span"
                                                style={{
                                                  color: isDark
                                                    ? '#fff'
                                                    : isLoggedUser
                                                    ? '#fff'
                                                    : '#000'
                                                }}
                                              >
                                                {(() => {
                                                  // Try to parse the content as JSON
                                                  try {
                                                    const jsonObject =
                                                      JSON.parse(v.content)
                                                    // If successful, it's valid JSON, so format it nicely
                                                    const prettyJson =
                                                      JSON.stringify(
                                                        jsonObject,
                                                        null,
                                                        2
                                                      )

                                                    return (
                                                      <pre
                                                        style={{
                                                          margin: 0,
                                                          whiteSpace:
                                                            'pre-wrap',
                                                          wordBreak:
                                                            'break-word',
                                                          color: isDark
                                                            ? '#fff'
                                                            : isLoggedUser
                                                            ? '#fff'
                                                            : '#000',
                                                          fontFamily:
                                                            'monospace',
                                                          fontSize: '0.85em'
                                                        }}
                                                      >
                                                        {prettyJson}
                                                      </pre>
                                                    )
                                                  } catch (e) {
                                                    // Not valid JSON, render as normal markdown
                                                    return (
                                                      <ReactMarkdown
                                                        components={{
                                                          p: ({
                                                            node,
                                                            ...props
                                                          }) => (
                                                            <p
                                                              style={{
                                                                color: isDark
                                                                  ? '#fff'
                                                                  : isLoggedUser
                                                                  ? '#fff'
                                                                  : '#000',
                                                                margin: '0'
                                                              }}
                                                              {...props}
                                                            />
                                                          ),
                                                          strong: ({
                                                            node,
                                                            ...props
                                                          }) => (
                                                            <strong
                                                              style={{
                                                                color: isDark
                                                                  ? '#fff'
                                                                  : isLoggedUser
                                                                  ? '#fff'
                                                                  : '#000',
                                                                fontWeight: 600
                                                              }}
                                                              {...props}
                                                            />
                                                          )
                                                        }}
                                                      >
                                                        {v.content}
                                                      </ReactMarkdown>
                                                    )
                                                  }
                                                })()}
                                              </span>
                                            </>
                                          )}
                                          {/* msg time & tick mark  */}
                                          <div
                                            className="d-flex flex-row align-items-end"
                                            style={{
                                              columnGap: '7px',
                                              height: '16px'
                                            }}
                                          >
                                            <span
                                              className="time"
                                              style={{
                                                fontSize: '9.5px',
                                                position: 'relative',
                                                top: '0.4rem',
                                                height: 'fit-content'
                                              }}
                                            >
                                              {v.createdAt
                                                ? moment(v.createdAt).format(
                                                    'hh:mm A'
                                                  )
                                                : 'N/A'}
                                            </span>
                                            {renderMessageStatus(
                                              v,
                                              isLoggedUser
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  )}
                                </div>
                              </div>
                            )}
                            <div
                              className="d-flex flex-column"
                              style={{ maxHeight: '50px' }}
                            >
                              <Button
                                variant="link"
                                size="sm"
                                style={{
                                  padding: 0,
                                  marginLeft: '5px',
                                  color: '#007bff',
                                  opacity: '0.3'
                                }}
                                onClick={() => setReplyingTo(v)} // Set the message to reply to
                                className="d-none d-md-inline"
                              >
                                <Reply style={{ color: '#000' }} />
                              </Button>
                              {/* <ReactionBar isLoggedUser={isLoggedUser} /> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )
                })}
            </div>
          ))}

          {istyping ? (
            <div>
              <Lottie
                options={defaultOptions}
                // height={50}
                width={70}
                style={{ marginBottom: 15, marginLeft: 0 }}
              />
            </div>
          ) : (
            <></>
          )}

          <div ref={messagesEndRef}></div>
        </div>
      </div>

      <Button
        variant="secondary"
        className={`scroll-to-bottom-btn ${isAtBottom ? 'hidden' : 'visible'}`}
        onClick={handleScrollToBottom}
        style={{
          position: 'fixed',
          bottom: `calc(${
            replyingTo ? '130px' : '70px'
          } + env(safe-area-inset-bottom, 0px))`, // Above the chat footer
          right: '15px',
          zIndex: 1000,
          borderRadius: '50%',
          width: '35px',
          height: '35px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <ChevronDown size={32} />
        {/* {newMessageCount > 0 && (
          <span
            className="badge badge-primary position-absolute"
            style={{
              top: '-8px',
              right: '-10px',
              fontSize: '10px',
              height: '18px',
              minWidth: '18px',
              borderRadius: '50%'
            }}
          >
            {newMessageCount}
          </span>
        )} */}
      </Button>

      {/* offcanvas for sharing items in footer  */}
      <div
        class="offcanvas offcanvas-bottom action-sheet inset"
        tabindex="-1"
        id="actionSheetAdd"
      >
        <div class="offcanvas-header">
          <h5 class="offcanvas-title">Share</h5>
        </div>
        <div class="offcanvas-body">
          <ul class="action-button-list">
            <li>
              <a href="#" class="btn btn-list" data-bs-dismiss="offcanvas">
                <span>
                  <ion-icon name="camera-outline"></ion-icon>
                  Camera
                </span>
              </a>
            </li>
            <li>
              <a href="#" class="btn btn-list" data-bs-dismiss="offcanvas">
                <span>
                  <ion-icon name="image-outline"></ion-icon>
                  Upload from Gallery
                </span>
              </a>
            </li>
            <li>
              <a
                href="#"
                className="btn btn-list"
                data-bs-dismiss="offcanvas"
                onClick={e => {
                  e.preventDefault()
                  fileInputRef.current.click() // Trigger file input click
                }}
              >
                <span>
                  <ion-icon name="document-outline"></ion-icon>
                  Files
                </span>
              </a>
            </li>
            <li>
              <a href="#" class="btn btn-list" data-bs-dismiss="offcanvas">
                <span>
                  <ion-icon name="musical-notes-outline"></ion-icon>
                  Sound file
                </span>
              </a>
            </li>
            <li>
              <a
                href="#"
                class="btn btn-list"
                data-bs-dismiss="offcanvas"
                onClick={e => {
                  e.preventDefault()
                  sendLocation()
                }}
              >
                <span>
                  <ion-icon name="location-outline"></ion-icon>
                  Location
                </span>
              </a>
            </li>
            {/* Stickers */}
            <li
              onClick={e => {
                e.preventDefault()
                handleShowStickers()
              }}
            >
              <a href="#" class="btn btn-list" data-bs-dismiss="offcanvas">
                <span className="gap-1">
                  <Sticker />
                  Stickers
                </span>
              </a>
            </li>
            <Modal show={modalStickers} onHide={handleCloseStickers} centered>
              <Modal.Header
                closeButton
                style={{
                  position: 'sticky',
                  top: '0',
                  zIndex: '2',
                  backgroundColor: '#fff'
                }}
              >
                <Modal.Title style={{ fontSize: '18px' }}>Stickers</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {showStickerPicker && (
                  <div className="sticker-picker">
                    {stickers.map(sticker => (
                      <img
                        key={sticker.id}
                        src={sticker.media_formats.tinygif.url}
                        alt="Sticker"
                        className="sticker-item"
                        onClick={() => {
                          sendSticker(sticker.media_formats.gif.url)
                          setModalStickers(false)
                        }}
                        onError={e => {
                          e.target.onerror = null // Prevent infinite loop
                          e.target.src =
                            'https://icon-library.com/images/anonymous-avatar-icon/anonymous-avatar-icon-25.jpg' // Fallback image
                        }}
                      />
                    ))}
                  </div>
                )}
              </Modal.Body>
            </Modal>
            {/* Poll */}
            <li>
              <a
                href="#"
                class="btn btn-list"
                data-bs-dismiss="offcanvas"
                onClick={e => {
                  e.preventDefault()
                  handleShowPoll()
                }}
              >
                <span>
                  <ion-icon name="stats-chart-outline"></ion-icon>
                  Poll
                </span>
              </a>
            </li>
            <Modal
              show={poll}
              onHide={handleClosePoll}
              centered
              fullscreen={window.innerWidth < 435}
            >
              <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: '18px' }}>
                  Create a Poll
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Question</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ask question"
                    value={pollQuestion}
                    onChange={handlePollQuestionChange}
                  />
                </Form.Group>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Options</Form.Label>
                  {pollOptions.map((option, index) => (
                    <Form.Control
                      key={index}
                      className="mb-2"
                      type="text"
                      placeholder={`Add option ${index + 1}`}
                      value={option}
                      onChange={e =>
                        handlePollOptionChange(index, e.target.value)
                      }
                    />
                  ))}
                  <div className="d-flex justify-content-end">
                    {pollOptions.length < 5 &&
                      pollOptions.every(opt => opt.trim() !== '') && (
                        <Button
                          variant="outline-dark"
                          className="w-25 mt-2"
                          onClick={addPollOption}
                        >
                          + Add Option
                        </Button>
                      )}
                    <div className="me-1">Allow multiple answers</div>
                    <div
                      class="form-check form-switch"
                      style={{ height: '20px', marginTop: '3px' }}
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="SwitchCheckDefault1"
                      />
                      <label
                        class="form-check-label"
                        for="SwitchCheckDefault1"
                        style={{ height: '18px' }}
                      ></label>
                    </div>
                  </div>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  // onClick={sendPoll}
                  onClick={handleClosePoll}
                  disabled={!isPollValid()}
                  style={{ width: '50px' }}
                >
                  <SendHorizontal />
                </Button>
              </Modal.Footer>
            </Modal>
          </ul>
        </div>
      </div>
      {/* offcanvas for sharing items  */}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
        accept="image/*,application/pdf,.doc,.docx,.txt"
      />

      {/* chat footer */}
      <div className="appBottomMenu d-block">
        <Form>
          <InputGroup className="input-with-icon m-auto pe-1 position-relative">
            <div className="mobilebadge pt-1">
              {replyingTo ? (
                <>
                  <div
                    style={{
                      backgroundColor: '#f1f1f1', // Light gray like WhatsApp
                      padding: '8px 10px',
                      borderRadius: '5px',
                      // marginBottom: '5px',
                      position: 'relative',
                      borderLeft: '3px solid #007bff', // Blue bar like WhatsApp
                      maxWidth: '100%',
                      wordWrap: 'break-word',
                      width: '100%',
                      marginLeft: '17px',
                      marginRight: '33px'
                    }}
                  >
                    <div
                      style={{
                        fontSize: '12px',
                        color: '#555',
                        fontWeight: 'bold'
                      }}
                    >
                      {replyingTo.sender?.name ||
                        selectedChat.users.find(
                          u => u._id === replyingTo.sender?._id
                        )?.name ||
                        'Unknown'}
                      {console.log(replyingTo)}
                    </div>
                    <div style={{ fontSize: '14px', color: '#000' }}>
                      {/* {replyingTo.content.length > 50
                      ? replyingTo.type.substring(0, 50) + '...'
                      : replyingTo.type} */}
                      {replyingTo.type === 'text'
                        ? replyingTo.content.substring(0, 40) + '...'
                        : replyingTo.type ||
                          replyingTo.content.substring(0, 40) + '...'}
                    </div>

                    <Button
                      variant="link"
                      size="sm"
                      style={{
                        position: 'absolute',
                        top: '5px',
                        right: '5px',
                        padding: 0
                      }}
                      onClick={() => setReplyingTo(null)} // Clear the reply
                    >
                      <CircleX size={16} style={{ color: '#EC4433' }} />
                    </Button>
                  </div>
                  <div
                    className="plus-icon"
                    style={{
                      position: 'absolute',
                      top: '76%',
                      zIndex: '10',
                      transform: 'translateY(-50%)'
                    }}
                  >
                    <Button
                      variant="light"
                      className="border-0 plus-btnn"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#actionSheetAdd"
                    >
                      <PlusCircle size={24} style={{ color: '#000' }} />
                    </Button>
                  </div>
                  <Form.Control
                    as="textarea"
                    ref={textareaRef}
                    rows={1}
                    placeholder="Message..."
                    value={newMessage}
                    onChange={typingHandler}
                    onKeyDown={handleKeyPress}
                    onSelect={handleSelection}
                    onClick={checkCursorPosition} // Check cursor position on click
                    onKeyUp={checkCursorPosition} // Check cursor position on key up
                    className="rounded bg-light mb-1"
                    style={{
                      resize: 'none',
                      minHeight: '40px',
                      maxHeight: '120px',
                      overflowY: 'auto',
                      paddingRight: '4.2rem',
                      paddingLeft: '40px',
                      flexGrow: 1
                    }}
                    onInput={e => {
                      e.target.style.height = '40px'
                      e.target.style.height = `${e.target.scrollHeight}px`
                    }}
                  />
                  {showToolbar && <MarkdownToolbar />}
                  {showSuggestions && (
                    <ul
                      ref={mentionListRef}
                      className="mention-dropdown"
                      style={{
                        position: 'absolute',
                        bottom: '50px',
                        left: '35px',
                        backgroundColor: 'white',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        borderRadius: '8px',
                        padding: '5px 0',
                        listStyle: 'none',
                        zIndex: 1000,
                        marginBottom: '10px',
                        width: '280px',
                        maxHeight: '150px',
                        overflowY: mentionList.length > 4 ? 'scroll' : 'hidden'
                      }}
                    >
                      {mentionList.map((user, index) => (
                        <li
                          key={user._id}
                          onClick={() =>
                            insertMention(user, textareaRef.current)
                          }
                          className={`mention-item ${
                            mentionIndex === index ? 'active' : ''
                          }`}
                          ref={el => (mentionItemRefs.current[index] = el)} // Store ref for scrolling
                          style={{
                            padding: '8px 12px',
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            backgroundColor:
                              mentionIndex === index ? '#e8e8e8' : 'white'
                          }}
                        >
                          <strong style={{ fontSize: '16px' }}>
                            {user.name}
                          </strong>
                          <p
                            style={{
                              fontSize: '12px',
                              width: 'fit-content',
                              marginTop: '0px'
                            }}
                          >
                            ~
                            {user.type === 'bot'
                              ? user.email
                              : formatPhoneNumber(user.phone)}
                          </p>
                        </li>
                      ))}
                    </ul>
                  )}
                  <div
                    className="plus-icon-btn align-items-center gap-1"
                    style={{
                      position: 'absolute',
                      top: '76%',
                      height: 'fit-content',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'transparent',
                      display: 'flex'
                    }}
                  >
                    {/* send and clear button */}
                    {isUserTyping || previewFile ? (
                      <>
                        <Button
                          variant="light"
                          className="h-auto w-50 p-0 ms-1"
                          onClick={clearInput}
                        >
                          <CircleX
                            size={20}
                            style={{
                              color: '#4F5050',
                              cursor: 'pointer'
                            }}
                          />
                        </Button>
                        <Button
                          type="submit"
                          variant="light"
                          className="border-0 text-primary"
                          onClick={sendMessage}
                          disabled={uploading}
                        >
                          {uploading ? (
                            'Sending...'
                          ) : (
                            <Send size={24} style={{ color: '#000' }} />
                          )}
                        </Button>
                      </>
                    ) : (
                      <div>
                        <Button
                          variant={isRecording ? 'danger' : 'light'}
                          className={`border-0 ${
                            isRecording ? 'mic-recording' : ''
                          }`}
                          style={{
                            width: isRecording ? '40px' : '',
                            borderRadius: isRecording ? '50%' : '',
                            left: isRecording ? '7.5px' : ''
                          }}
                          onClick={isRecording ? stopRecording : startRecording}
                        >
                          {isRecording ? (
                            <span>
                              <Mic size={22} style={{ color: '#fff' }} />
                              <p
                                className="m-0 align-items-center"
                                style={{
                                  fontSize: '10px',
                                  width: 'fit-content',
                                  color: '#fff'
                                }}
                              >
                                {formatTime(recordingTime)}
                              </p>
                            </span>
                          ) : (
                            <Mic size={24} style={{ color: '#000' }} />
                          )}
                        </Button>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div
                    className="plus-icon"
                    style={{
                      position: 'absolute',
                      top: '48%',
                      zIndex: '10',
                      transform: 'translateY(-50%)'
                    }}
                  >
                    {/* File Preview Section */}
                    {previewFile ? (
                      <div
                        style={{
                          position: 'relative',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px'
                        }}
                      >
                        {previewFile.type.startsWith('image/') ? (
                          <img
                            src={previewFile.preview}
                            alt="Preview"
                            style={{
                              width: '40px',
                              height: '40px',
                              objectFit: 'cover',
                              borderRadius: '5px'
                            }}
                            onError={e => {
                              e.target.onerror = null // Prevent infinite loop
                              e.target.src =
                                'https://icon-library.com/images/anonymous-avatar-icon/anonymous-avatar-icon-25.jpg' // Fallback image
                            }}
                          />
                        ) : (
                          <ion-icon
                            name={
                              previewFile.type === 'application/pdf'
                                ? 'document-outline'
                                : previewFile.type.includes('word')
                                ? 'document-text-outline'
                                : 'document-outline'
                            }
                            style={{ fontSize: '24px', color: '#000' }}
                          ></ion-icon>
                        )}
                        <Button
                          variant="light"
                          className="border-0 p-0"
                          style={{
                            position: 'absolute',
                            top: '-15px',
                            right: '-5px'
                          }}
                          onClick={() => {
                            setPreviewFile(null)
                            URL.revokeObjectURL(previewFile.preview)
                            setIsUserTyping(false)
                          }}
                        >
                          <CircleX size={20} style={{ color: '#EC4433' }} />
                        </Button>
                      </div>
                    ) : (
                      <>
                        <Button
                          variant="light"
                          className="border-0 plus-btnn pt-0 pb-0"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#actionSheetAdd"
                          style={{ height: '30px', borderRadius: '50%' }}
                        >
                          <PlusCircle
                            size={24}
                            style={{ color: isDark ? '#fff' : '#000' }}
                          />
                        </Button>
                      </>
                    )}
                  </div>
                  <Form.Control
                    as="textarea"
                    ref={textareaRef}
                    rows={1}
                    placeholder="Message..."
                    value={newMessage}
                    onChange={typingHandler}
                    onKeyDown={handleKeyPress}
                    onSelect={handleSelection}
                    onClick={checkCursorPosition} // Check cursor position on click
                    onKeyUp={checkCursorPosition} // Check cursor position on key up
                    className="rounded bg-light mb-1"
                    style={{
                      resize: 'none',
                      minHeight: '40px',
                      maxHeight: '120px',
                      overflowY: 'auto',
                      paddingRight: '4.2rem',
                      paddingLeft: '40px',
                      flexGrow: 1,
                      color: isDark ? '#fff' : '#000'
                    }}
                    onInput={e => {
                      e.target.style.height = '40px'
                      e.target.style.height = `${e.target.scrollHeight}px`
                    }}
                  />
                  {showToolbar && <MarkdownToolbar />}
                  {showSuggestions && (
                    <ul
                      ref={mentionListRef}
                      className="mention-dropdown"
                      style={{
                        position: 'absolute',
                        bottom: '50px',
                        left: '35px',
                        backgroundColor: 'white',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        borderRadius: '8px',
                        padding: '5px 0',
                        listStyle: 'none',
                        zIndex: 1000,
                        marginBottom: '10px',
                        width: '280px',
                        maxHeight: '150px',
                        overflowY: mentionList.length > 4 ? 'scroll' : 'hidden'
                      }}
                    >
                      {mentionList.map((user, index) => (
                        <li
                          key={user._id}
                          onClick={() =>
                            insertMention(user, textareaRef.current)
                          }
                          className={`mention-item ${
                            mentionIndex === index ? 'active' : ''
                          }`}
                          ref={el => (mentionItemRefs.current[index] = el)} // Store ref for scrolling
                          style={{
                            padding: '8px 12px',
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            backgroundColor:
                              mentionIndex === index ? '#e8e8e8' : 'white'
                          }}
                        >
                          <strong style={{ fontSize: '16px' }}>
                            {user.name}
                          </strong>
                          <p
                            style={{
                              fontSize: '12px',
                              width: 'fit-content',
                              marginTop: '0px'
                            }}
                          >
                            ~
                            {user.type === 'bot'
                              ? user.email
                              : formatPhoneNumber(user.phone)}
                          </p>
                        </li>
                      ))}
                    </ul>
                  )}
                  {/* send and clear button */}
                  <div
                    className="plus-icon-btn align-items-center gap-1"
                    style={{
                      position: 'absolute',
                      top: '52%',
                      height: 'fit-content',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'transparent',
                      display: 'flex'
                    }}
                  >
                    {isUserTyping || previewFile ? (
                      <>
                        <Button
                          variant="light"
                          className="h-auto w-50 p-0 ms-1 plus-btnn"
                          onClick={clearInput}
                        >
                          <CircleX
                            size={20}
                            style={{
                              color: isDark ? '#fff' : '#000',
                              cursor: 'pointer'
                            }}
                          />
                        </Button>
                        <Button
                          type="submit"
                          variant="light"
                          className="border-0 text-primary plus-btnn"
                          onClick={sendMessage}
                          disabled={uploading}
                        >
                          {uploading ? (
                            'Sending...'
                          ) : (
                            <Send
                              size={24}
                              style={{ color: isDark ? '#fff' : '#000' }}
                            />
                          )}
                        </Button>
                      </>
                    ) : (
                      <div>
                        {/* <Button
                      variant="light"
                      className="border-0"
                      onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                    >
                      <EmojiSmile size={22} style={{ color: '#000' }} />
                    </Button>

                    {showEmojiPicker && (
                      <div className="emoji-picker-container">
                        <EmojiPicker onEmojiClick={handleEmojiClick} />
                      </div>
                    )} */}
                        <Button
                          variant={isRecording ? 'danger' : 'light'}
                          className={`border-0 plus-btnn ${
                            isRecording ? 'mic-recording' : ''
                          }`}
                          style={{
                            width: isRecording ? '40px' : '',
                            borderRadius: isRecording ? '50%' : '',
                            left: isRecording ? '7.5px' : '',
                            height: '30px',
                            borderRadius: '50%'
                          }}
                          onClick={isRecording ? stopRecording : startRecording}
                        >
                          {isRecording ? (
                            <span>
                              <Mic size={22} style={{ color: '#fff' }} />
                              <p
                                className="m-0 align-items-center"
                                style={{
                                  fontSize: '10px',
                                  width: 'fit-content',
                                  color: '#fff'
                                }}
                              >
                                {formatTime(recordingTime)}
                              </p>
                            </span>
                          ) : (
                            <Mic
                              size={24}
                              style={{ color: isDark ? '#fff' : '#000' }}
                            />
                          )}
                        </Button>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </InputGroup>
        </Form>
      </div>
    </>
  )
}

const mapStateToProps = ({ data, auth }) => {
  const { selectedChat, notification, socketConnected } = data
  const { userInfo, authToken } = auth

  return {
    selectedChat,
    userInfo,
    authToken,
    notification,
    socketConnected
  }
}
const mapDispatchToProps = {
  setSelectedChat,
  setNotification,
  setSocketConnected,
  setShowCallModal,
  setCallDetails,
  setChatList,
  setCallData
}

const ConnectedUserChatView = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserChatView)
export default ConnectedUserChatView // Default export
export { UserChatView } // Named export
